import React, { Fragment } from 'react';
import { Link, HashRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { setBookingRef, setCheckinRoomNo, getAllergyOptions, getCountryOptions, getCardChecksData, cardValidation, setSelfieVideo, setIdCardImage, setIdCardImageBack, setCheckinCurrentPageName, setSelectedIdType, setAccompanyGuestData, setCheckinWidgetLaunchTime, GetDynamicBookingForm, getAccompanyguestDynamicBookingForm, setAbortCheckinProcess } from '../../action/autoCheckin';
import axios from 'axios';
import { CLICKED, CMSPath, defultIP, ELAVON_UPDATED_FLOW, EMAIL_MANDATORY, ENABLE_US_DATE_FORMAT, globalIV, globalSalt, IDCARD_DEMO, PHONE_MANDATORY, SHOW_GDPR_BEFORE_ID_AND_SELFIE_SCAN, WEB_VERSION_ENABLED } from '../../../config/constant';
import {
  setRegPage, setLoadingMass,
  validateGuestdetail, popupOpenClose,
  setDeviceLoginPage, currentWidget, setCheckInAddress, setPreCheckInBookingState,
  updateAdhocData,
  showAdhocAction,
  setShowAutoLoginPopup,
  setShowCustomPopup
} from '../../../action/action'
import { fetchSessionToken } from '../../../JS/fetchSessionToken'
import clientConfigApi from '../../../config/config';
import { data } from 'jquery';
import moment from 'moment';
import { mobileCheckinColorConfig } from '../../JS/colorConfig'
import AddCard from './lightbox.jsx';
import AddCard2 from './lightbox2.jsx';
import APIFailScreen from './apiFailScreen';
import {withTranslation} from 'react-i18next'
import Loader from '../../UI/loader';
import {ENABLE_CREDIT_CARD_SCREEN, SHOW_ALLERGY_OPTIONS} from '../../../config/constant'
import SuccessFailScreen from '../../UI/SuccessFailScreen';
import StripeCardFlow from './addCardStripe.jsx'
import { setGoHome } from '../../action/homeAction';
import { getDefaultAnalyticsLabel, toBool } from '../../JS/utility';
import { getGuestDocListData, sendAnalytics } from '../../../action/homeAction';
import AccompanyingGuestInput from './accompanyingGuestInput';
import IdCardCapture from './index'
import SelfieCapture from './VerifyIdentity'
import VerifyConfidance from './ConfidenceShow'
import LoggedInErrorScreen from './apiFailScreen'
import CheckinStepsGuide from './checkinStepsGuide';
import GdprPolicy from './gdprPolicy';
import { scrollToTop } from '../../../JS/scrollToTop';
import { dateFormatHandler } from "../../../JS/dateFormatHandler"
import AccompanyingGuestDetailsInput from './accompanyingGuestDetailsInput';
import ClearVerification from './clearVerification';
import Shift4 from './shift4';
import BookingForm from './bookingForm';
import PreCheckInSuccess from './PreCheckInSuccess';
import { AesUtil } from '../../../JS/AesUtil';
import EarlyCheckInPopUP from './earlyCheckInPopUp';
import ResvInQueuePopUP from './resvInQueuePop';
import AccompanyingGuestFreeForm from './accompanyingGuestFreeForm';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import AccompanyingGuestDynamicForm from './accompanyingGuestDynamicForm';
import Disclaimer from './disclaimer.jsx';
import { getGuestItinerary } from '../../../action/guestItinerary.js';
import Shift4_V2 from './Shift4_V2.jsx';
import { handlePreCheckInStorage } from '../hotelSelector/hotelSelector.js';
import { fetchAdhoc } from '../../action/adhoc.js';
import ScanIdandSelfieTogether from './ScanIdandSelfieTogether/index.jsx';
import { handleGuestBookingConflict } from './helper';
import FreedomPay from './freedomPay1.jsx';
import Upsells from '../upsells/upsells.jsx';
import { fetchUpsells } from '../../action/upsells.js';
import { inAppBrowser } from '../../JS/inAppBrowser.js';
import GdprBeforeIdAndSelfieScan from './GdprBeforeIdAndSelfieScan.jsx';
import { wipeGuestData } from '../../../JS/wipeGuestData.js';
import Planet from './Planet/Planet.jsx';


class Booking extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        todayDate: null,
        inputDateFormat: null,
        selectedDate: null,
        selectedComp: null,
        sessionToken: localStorage.getItem('GuestJourneySessionToken'),
        roomNo: '',
        loderMessage: '',
        inProgress: false,
        roomLinkSuccess: false,
        roomLinkFailed: false,
        selectAllergy: 'None',
        email:'',
        countryPhoneCode:null,
        phone:null,
        firstName: "",
        lastName:'',
        eta: "",
        extraData: null,
        showCardVerified: false,
        cardVerified: false,
        bookingNumber:'',
        reservationNumber: "",
        guest_book_error: false,
        guest_book_error_msg: null,
        guest_book_loading:false,
        checkinGuest_loading:false,
        checkinGuest_error:false,
        checkinGuest_error_msg:null,
        checkinGuest_success:false,
        errorScreenShown: false,
        showLoader: false,
        CLEARLoader: false,
        cardToken: "",
        firstLaunch: true,
        idImageArray: [],
        address:{
          "addressLine1": "",
          "addressLine2": "",
          "city": "",
          "state": "",
          "postalCode": "",
          "country": ""
        },
        birthDate: "",
        confirmationNumber:null,
        otherAllergies: "",
        goBack:false,
        showFailScreenHeader: null,
        showFailScreen:false,
        apiFailErrorMsg:null,
        setupIntentSecret: "",
        goToFirstStep: false,
        showIdCardCapture: false,
        showSelfieCapture: false,
        showVerifyConfidance: false,
        showErrorScreen: false,
        showGDPR: false,
        clearVerification: false,
        dynamicFormIndex: 0,
        DynamicBookingFormRequestData: [],
        accompanyGuestDynamicFormRequestData: [],
        showAccompanyGuestFlow: false,
        showReservationInQueuePopup: false,
        askEarlyCheckIn: false,
        doEarlyCheckIn: false,
        userFinishedCheckInFlow: false,
        isPreCheckInDone: false,
        preCheckInSuccess: false,
        renderDateInput: false,
        showDisclaimer: false,
        isUpsellsAvailable: false,
        showUpsells: false,
        continueUpsell: false,
        arrivalDate: "",
        departureDate: "",
        noOfAccompanyGuestChild: 0,
        noOfAccompanyGuestAdult: 0,
        disclaimerAccepted: false,
        checkinSessionToken: localStorage.getItem("checkinSessionToken"),
        shownGdprBeforeIdAndSelfieScan: false
        
    }
    this.getObject = this.getObject.bind(this);
    this.handleBookingRefNo = this.handleBookingRefNo.bind(this);
    this.doCheckin = this.doCheckin.bind(this);
    this.callBackFunc = this.callBackFunc.bind(this);
    this.guestBookingHandler = this.guestBookingHandler.bind(this);
    this.checkInInfoHandler = this.checkInInfoHandler.bind(this);
    this.checkInGuestHandler = this.checkInGuestHandler.bind(this);
    this.preCheckInGuestHandler = this.preCheckInGuestHandler.bind(this);
    this.preCheckInSuccessNext = this.preCheckInSuccessNext.bind(this);
    this.earlyCheckInConfirmFunc = this.earlyCheckInConfirmFunc.bind(this);
    this.handleCheckinWorkflow = this.handleCheckinWorkflow.bind(this);
    this.addressHandler = this.addressHandler.bind(this);
    this.handlePreCheckInSelectedDate = this.handlePreCheckInSelectedDate.bind(this);
    this.readFile = this.readFile.bind(this);
    this.guestBookFormData = new FormData();
    this.disclaimerFormData = new FormData();
    this.checkinRoomNum = null;
    this.maxRetry = this.props.cardChecksData.guestValidationMaxRetry ? this.props.cardChecksData.guestValidationMaxRetry : 3 ;
    this.addressFlagCount = 0;
    this.aesUtil = new AesUtil(128, 1000);
    this.dateInputCss = `
    .rdp-day_selected {
        color: ${this.props.menuColor.assetFontSelectorColor};
        background-color: ${this.props.menuColor.assetBackgroundSelectorColor};
    }`;
    this.emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  }

  getObject(key) {

    if (!this.props.idCardResponse){
      return null;
    }

    if(key=='raw_text'){
      let rawText = this.props.idCardResponse.raw_text ? this.props.idCardResponse.raw_text.join(",") : "";

      if(rawText !== "None" && rawText !== "none" && rawText !== "undefined"){
        return rawText;
      }
    }

    if(key=='idType'){
      let rawText = this.props.idCardResponse.type.name;

      if(rawText !== "None" && rawText !== "none" && rawText !== "undefined"){
        return rawText;
      }
    }

    let obj = {}
    for (obj of this.props.idCardResponse.fields){
      if (obj.key == key){
        if(obj.value !== "None" && obj.value !== "none" && obj.value !== "undefined"){
          return obj.value;
        }
      }
    }
    return null;
  }


  clearGuestBookData = () => {
    this.guestBookFormData.delete('confirmationNumber');
    this.guestBookFormData.delete('firstName');
    this.guestBookFormData.delete('lastName');
    this.guestBookFormData.delete("sessionToken");
    this.guestBookFormData.delete("actionKey");
    this.guestBookFormData.delete("flowIntent");
    this.guestBookFormData.delete("roomNumber");
  };


  addressHandler(event){
    const updtAdd = {...this.state.address,
      [event.target.name]: event.target.value};
  
    this.setState({address:updtAdd})
  }

  callBackFunc(status, room, locationId, errMsg) {
    let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
    if(status){
      localStorage.setItem('room', room);
      this.setState({preCheckInSuccess: false});
      this.setState({checkinGuest_loading:false, showLoader:false});
      this.setState({inProgress: false, roomLinkFailed: false, roomLinkSuccess: true});

      this.props.sendAnalytics(
        this.props.guestDetail,
        "LINK_TO_ROOM",
        "link to room - success",
        { ...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget"},
        0,
        (room && room != "null") ? room : false
      );
    }else{
      this.props.sendAnalytics(
        this.props.guestDetail,
        "LINK_TO_ROOM",
        "link to room - failed",
        { ...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget" },
        0,
        (room && room != "null") ? room : false
      );
      this.maxRetry = this.maxRetry-1
      if(this.maxRetry <= 0){
        this.setState({checkinGuest_loading:false , showLoader:false ,showFailScreen:true, apiFailErrorMsg: "We could not find your records for check-in. Please verify your details and try again or contact the Front Desk",exitCheckinFlow: true, inProgress: false, roomLinkFailed: true, roomLinkSuccess: false});
      }else{
        this.setState({checkinGuest_loading:false , showLoader:false ,showFailScreen:true, apiFailErrorMsg: errMsg, inProgress: false, roomLinkFailed: true, roomLinkSuccess: false})
      }
    }
  }

  earlyCheckInConfirmFunc(){

    let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})

    if(!localStorage.getItem("early_checkIn_event_sent")){
      this.props.sendAnalytics(
        null, // as no guesdetails in logout state 
        this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
        "EARLY CHECKIN - Next", 
        {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING DETAILS" , "widgetSessionId": this.state.checkinSessionToken, userCompletedCheckInFlow: this.state.userFinishedCheckInFlow, preCheckInDoneFromSameDevice: localStorage.getItem("X_CHECKIN_PQ_DATA") ? true : false },
        0, 
        false, // guest is not logged in
        () => localStorage.setItem("early_checkIn_event_sent", true)
    )}

    this.setState({doEarlyCheckIn: true, askEarlyCheckIn: false}, () => {
      if(localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")){
        this.guestBookingHandler("", "AfterPreCheckInCacheRenewel", "", "bookingEnquiry");
      } else {
        this.guestBookingHandler("", "", "", "bookingDataEnquiry");
      }
    });
  }

  async preCheckInSuccessNext(){
    let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
    this.props.sendAnalytics(
      null, // as no guesdetails in logout state 
      this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
      "PRE CHECK-IN PAGE - Next", 
      {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING NUMBER", "widgetSessionId": this.state.checkinSessionToken, userCompletedCheckInFlow: this.state.userFinishedCheckInFlow },
      0, 
      false, // guest is not logged in
    );

    await this.props.currentWidget({...this.props.currentWidgetObj, widgetType: "Mobile Check-in"});

    // below call we are doing for cache renewal for checkIn flow, if this call give success checkIn call is made
    setTimeout(() => {
      this.guestBookingHandler("", "AfterPreCheckInCacheRenewel", "", "bookingEnquiry");
    }, 10);
  }

  doCheckin(){
    this.setState({inProgress: true, roomLinkFailed: false, roomLinkSuccess: false});
    let lastName = this.state.lastName;
    let roomNumber = this.checkinRoomNum;
    let booking_number = this.state.bookingNumber
    const isAccompanyGuest = Boolean(
      this.state.profileId &&
      this.props.accompanyGuests &&
      this.props.accompanyGuests.find(guest => guest.profileId == this.state.profileId)
    );
    const isAccompanyLogin = isAccompanyGuest
      ? {
          guestNotVerified: true,
          guestId: this.state.profileId
        }
      : {};

    let encodData = fetchSessionToken();
    this.props.validateGuestdetail(encodData, lastName, roomNumber, this.callBackFunc, booking_number, undefined, isAccompanyLogin);
  }

 
  handleBookingRefNo(event){
    let value = event.target.value;
    this.setState({bookingNumber:value});
    this.props.setBookingRef(value);
    /*
    if (value && value.length > 7){
      let room_no = value.substring(4,7);
      this.props.setCheckinRoomNo(room_no);
      this.setState({roomNo: room_no})
    }*/
    // console.log(value);
    
  }

  handlePreCheckInSelectedDate = (selectedDate) => {

    if (!selectedDate) {
      this.setState({ selectedDate: this.state.todayDate, inputDateFormat: dateFormatHandler(new Date(this.state.todayDate).toISOString(), this.props.dateFormat)})
    } else {

        // converting to local date string
        const year = selectedDate.getFullYear();
        const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
        const day = String(selectedDate.getDate()).padStart(2, '0');

        const localDateString = `${year}-${month}-${day}`;
        this.setState({ selectedDate: localDateString, inputDateFormat: dateFormatHandler(new Date(localDateString).toISOString(), this.props.dateFormat)})
    }

    this.setState({ renderDateInput: false})
  }

  resOnError = (error) => {
    console.log('error: ', error);
      alert("resOnError - " + error.code);
  }

  readFile(uri, form_key,formData, callback){

    const self = this;
    function readBinaryFile(fileEntry) {
      fileEntry.file(function (file) {
          var reader = new FileReader();

          reader.onloadend = function() {
              var blob = new Blob([new Uint8Array(this.result)], { type: file.type });
              formData.append(form_key, blob, fileEntry.name);
              // console.log("file read: ", form_key);
              if(callback){
                callback()
              }

          };

          reader.readAsArrayBuffer(file);

      }, self.resOnError);
    }

    const convertUrlToBinaryWeb = (dataURL) => {
      const arr = dataURL.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    }

    // console.log('reading file: ', form_key);
    if(window.cordova && uri.startsWith("file:")) {
      window.resolveLocalFileSystemURL(uri, readBinaryFile, self.resOnError)
    } else {
      const blob = convertUrlToBinaryWeb(uri);
      formData.append(form_key, blob, 'image.jpg');

      if (callback) {
        callback();
      }
    }

  }

  dateFormatHandler = (date) => {

    if(!date){
      return null;
    }

    let now = moment(date);
   
    if(!now.date()){
      now = moment(date,"DD-MM-YYYY");
    }

    return now ? now.format("YYYY-MM-DD") : null;
  }

  cardValidationCallback = (setupIntentSecret, error) => {
    console.log('setupIntentSecret  from booking', setupIntentSecret)
    let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})

    if(setupIntentSecret){
     this.setState({setupIntentSecret: setupIntentSecret})
     this.setState({showLoader: false})
     this.setState({guest_book_error:false, selectedComp: "screen3"});
     scrollToTop()
    } else {
     this.props.popupOpenClose(true, error && error.msg || "Something went wrong")
     this.setState({showBookingField: true, showLoader: false})
     this.props.sendAnalytics(
      null, // as no guesdetails in logout state 
      this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
      "CREDIT CARD DETAILS REGISTER API - FAILED", 
      {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING NUMBER", "errorMessage": error && error.msg || "Something went wrong", "widgetSessionId": this.state.checkinSessionToken},
      0, 
      false // guest is not logged in
  );
    }
   }


  checkIDLastName = () => {

    let rawData = this.getObject("raw_text").toLowerCase();

    if(!rawData.includes(this.state.lastName.trim().toLowerCase())){
      this.props.popupOpenClose(true, "Last name entered does not match with the last name on the ID");
      this.setState({selectedComp: null, showVerifyConfidance: false})
      this.props.setSelectedIdType(null);
      this.props.setIdCardImageBack(null)
      this.props.setIdCardImage(null)
      this.props.setSelfieVideo(null)
      scrollToTop()
      return;
    }

    this.setNextScreen("VerifyIdAndSelfie");
  }

  setNextScreen = (callingFunction) => {

    if(callingFunction == "clearIDVerification"){
      this.guestBookingHandler("", "clearIDVerification", "", "bookingEnquiry")
      return;
    }

    if(callingFunction == "VerifyIdAndSelfie"){
      if(this.props.cardChecksData.guestImagesCheckEnabled && this.props.accompanyGuests.length > 0){
        this.setState({selectedComp: "screen2", showVerifyConfidance: false})
        scrollToTop()
      } else {
        this.setState({showVerifyConfidance: false})
        this.guestBookingHandler("", "", "", "bookingEnquiry")
      }
      return
    }

    if(this.props.cardChecksData.cardValidationEnabled){
      // this.props.cardValidation("register", response.data.payload.confirmationNumber, this.cardValidationCallback)
      this.setState({guest_book_error:false, selectedComp: "screen3", showVerifyConfidance: false});
      scrollToTop()
    } else {
      this.setState({guest_book_error:false, selectedComp: "screen4", showVerifyConfidance: false}); // change to scree3 to enable card details capture
      scrollToTop()
    }
  }

  guestBookingHandler(surname, callingFunction, idImageArray, actionKey,isConflictFlow=false){

    let lastName;
    let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
    if(callingFunction == "componentDidMount"){
      lastName = surname;
    }else{
      lastName = this.state.lastName

      // let rawData = this.getObject("raw_text").toLowerCase();
      // if(!rawData.includes(lastName.trim().toLowerCase())){
      //   this.props.popupOpenClose(true, "Last name entered does not match with the last name on the ID");
      //   return;
      // }      

      if (!this.state.lastName && this.state.bookingNumber) {
          this.props.popupOpenClose(true, "Please enter your last name");
          return;
      }
      if (this.state.lastName && !this.state.bookingNumber && this.state.errorScreenShown) {
          this.props.popupOpenClose(true, `Please enter your ${this.props.cardChecksData.bookingNumberLabel || "booking / reference number"}`);
          return;
      }
      if (!this.state.lastName && !this.state.bookingNumber && this.state.errorScreenShown) {
          this.props.popupOpenClose(true, `Please enter your last name / ${this.props.cardChecksData.bookingNumberLabel || "booking number"}`);
          return;
      }

      if(!this.state.selectedDate){
        this.props.popupOpenClose(true, `Please enter your check-in date`);
        return;
      }
    }
    if(lastName){
      const resolvedActionKey = actionKey ? actionKey : this.props.cardChecksData.guestImagesCheckEnabled && this.props.accompanyGuests.length == 0 && this.state.selectedComp == null ? "bookingDataEnquiry" : "bookingEnquiry";
      const shouldSendFirstName = resolvedActionKey === "bookingEnquiry" && this.state.firstName && this.state.firstName.trim();
      if(!isConflictFlow) this.guestBookFormData.delete('confirmationNumber');
      if(!isConflictFlow && !shouldSendFirstName) this.guestBookFormData.delete('firstName');
      this.guestBookFormData.delete('lastName');
      this.guestBookFormData.delete("sessionToken");
      this.guestBookFormData.delete("actionKey");
      this.guestBookFormData.delete("legNumber");
      this.guestBookFormData.delete("checkinDate");
      this.guestBookFormData.delete(`docType`);
      this.guestBookFormData.delete(`image`);
      this.guestBookFormData.delete("checkInType");
      this.guestBookFormData.delete("isEarlyCheckIn");

      console.log("idImageArray",idImageArray)

      if (idImageArray){
        idImageArray.map(guest => {
          this.guestBookFormData.delete(`${guest.profileId}_docType`);
          this.guestBookFormData.delete(`${guest.profileId}_image`);
        })
      }

      this.setState({showLoader: true})
      this.setState({guest_book_loading:true});
      if(!isConflictFlow && (resolvedActionKey !== "bookingEnquiry" || shouldSendFirstName)) this.guestBookFormData.append('confirmationNumber',this.state.bookingNumber.trim());
      if(shouldSendFirstName){
        this.guestBookFormData.delete('firstName');
        this.guestBookFormData.append('firstName', this.state.firstName.trim());
      }
      this.guestBookFormData.append('lastName',lastName.trim());
      this.guestBookFormData.append("sessionToken",this.state.sessionToken);
      this.guestBookFormData.append("actionKey", resolvedActionKey);
      this.guestBookFormData.append("legNumber","");
      this.guestBookFormData.append("checkinDate",this.state.selectedDate);
      if(this.props.externalSignIn.memberId) this.guestBookFormData.append("loyaltyRewardId", this.props.externalSignIn.memberId);

      // console.log("Guest booking form data",Array.from(formData));

      if(this.guestBookFormData.get("actionKey") == "bookingEnquiry" && this.props.selectedIdType && this.props.selectedIdType.value){
        // below check is for if it's CLEAR flow or if pre-checkIn is done then no need for docType and image.
        if(!(this.props.cardChecksData.idValidationInterface == "Clear" || this.props.cardChecksData.idValidationInterface == "disabled") && !localStorage.getItem("X_CHECKIN_PQ_DATA") && !sessionStorage.getItem("X_CHECKIN_PQ_DATA")){
        console.log("checking for bookingEnquiry", this.props.selectedIdType)
        this.guestBookFormData.append("docType", this.props.selectedIdType.value);
        console.log("checking for bookingEnquiry this.props.selectedIdType")
        if(this.props.selfieVideo){
          this.readFile(this.props.selfieVideo.videoUrl,"image",this.guestBookFormData);
        }
        
        if(this.props.idCardImage){
          this.readFile(this.props.idCardImage.imageUrl,"image",this.guestBookFormData);
        }}
        // if(this.props.idCardImageBack && this.props.selectedIdType.bothSideImageRequired){
        //   this.readFile(this.props.idCardImageBack.imageUrl,"image",this.guestBookFormData);
        // }
      }

      if(this.state.doEarlyCheckIn){
        this.guestBookFormData.append("isEarlyCheckIn", this.state.doEarlyCheckIn);
      }
      
      if(this.props.preCheckInEnabled){
      if(this.props.currentWidgetObj.widgetType == "Pre Check-in" || this.state.isPreCheckInDone == false){
        this.guestBookFormData.append("checkInType","precheckin");
      }}

      // resetting disclaimer
      if(actionKey == "bookingDataEnquiry"){
        this.setState({disclaimerAccepted: false});
      }

      if(this.props.cardChecksData.guestImagesCheckEnabled && this.props.accompanyGuests.length > 0 && idImageArray){
        // this.guestBookFormData.append("actionKey",this.props.cardChecksData.guestImagesCheckEnabled && this.props.accompanyGuests.length == 0 ? "bookingDataEnquiry" : "bookingEnquiry");
        let count = 0
        idImageArray.map(guest => {
          this.guestBookFormData.append(`${guest.profileId}_docType`, guest.docType);
          // this.guestBookFormData.append(`${guest.profileId}_image`, guest.imageURI);
          this.readFile(guest.imageURI,`${guest.profileId}_image`,this.guestBookFormData, () => {
            count = count + 1;
            console.log("read file count", count)
            if(count == idImageArray.length){
              setTimeout(() => {
                this.callBookingAPI(callingFunction, label, actionKey)
              }, 1500)
            }
          });
        })
      } else {
        this.setState({idImageArray: []});
        setTimeout(() => {
          this.callBookingAPI(callingFunction, label, actionKey)
        }, 1500)
      }
    } else {
      this.setState({showLoader: false})
      this.setState({CLEARLoader: false})
    }
  }

  callBookingAPI = (callingFunction, label, action) => {
    console.log("calling booking api")
    clientConfigApi.post(
      "/mobileCheckIn/guestBooking",this.guestBookFormData)
      .then((response) => {
        // this.clearGuestBookData();
        this.setState({guest_book_loading:false});
        if (response.status != 200){
          this.setState({showLoader: false});
          this.setState({CLEARLoader: false})
          if(callingFunction != "componentDidMount"){
            console.log("error !ok",response);
            this.setState({guest_book_error:true, showFailScreen:true, guest_book_error_msg:response.header.status.msg})  

            this.props.sendAnalytics(
                null, // as no guesdetails in logout state 
                this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
                callingFunction == "accGuest" || callingFunction == "callBookingAPI" ? "COMPANION DETAILS - FAILED" : "BOOKING NUMBER - FAILED", 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": callingFunction == "accGuest" ? "COMPANION DETAILS" : "BOOKING NUMBER", "errorMessage": response.header.status.msg,  "widgetSessionId": this.state.checkinSessionToken, checkinDate: this.state.selectedDate },
                0, 
                false // guest is not logged in
            );
          }
          
        } else {

          // add check for action dataEnquiry

          const checkin_fchbooking_event_sent = localStorage.getItem("checkin_fchbooking_event_sent")
          if(!checkin_fchbooking_event_sent)
          this.props.sendAnalytics(
              null, // as no guesdetails in logout state 
              this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
              "BOOKING NUMBER - SUCCESS", 
              {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": callingFunction == "accGuest" ? "COMPANION DETAILS" : "BOOKING NUMBER", "widgetSessionId": this.state.checkinSessionToken, isPreCheckInDone: (response.data.payload.isPreCheckInDone == false || response.data.payload.isPreCheckInDone == true) ? response.data.payload.isPreCheckInDone : "NA"},
              0, 
              false, // guest is not logged in
              () => localStorage.setItem("checkin_fchbooking_event_sent", true)
          );

          const checkin_companion_event_sent = localStorage.getItem("checkin_companion_event_sent")
          if(callingFunction == "accGuest" || callingFunction == "callBookingAPI" ){
            if(!checkin_companion_event_sent)
            this.props.sendAnalytics(
                null, // as no guesdetails in logout state 
                this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
                "COMPANION DETAILS - SUCCESS", 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": callingFunction == "accGuest" ? "COMPANION DETAILS" : "BOOKING NUMBER", "widgetSessionId": this.state.checkinSessionToken},
                0, 
                false, // guest is not logged in
                () => localStorage.setItem("checkin_companion_event_sent", true)
            );
          }


          if(callingFunction == "beforePreCheckInCacheRenewel"){
            this.handleCheckinWorkflow();
            return;
          }

          if(callingFunction == "AfterPreCheckInCacheRenewel"){
            this.checkInGuestHandler({takeDataFromLocalStorage: true});
            return;
          }
          
          this.setState({showLoader:false});
          this.setState({CLEARLoader: false})

          if(action == "bookingDataEnquiry"){this.props.setAccompanyGuestData(response.data.payload.accompanyingGuestDetails)};
          sessionStorage.removeItem("accompanyGuestDynamicFormFilledOnce");
          this.setState(response.data.payload);
          response.data.payload.phoneNumber && this.setState({phone: response.data.payload.phoneNumber})
          this.setState({ bookingNumber: response.data.payload.confirmationNumber})
          this.setState({reservationNumber: response.data.payload.reservationNumber || ""});
          localStorage.setItem("checkinSessionBookingNumber", response.data.payload.confirmationNumber)
          this.setState({address: response.data.payload.address})
          response.data.payload.address && Object.keys(response.data.payload.address).length > 0 && this.props.setCheckInAddress({...this.props.checkInAddress,...response.data.payload.address})
          response.data.payload.email && this.setState({email: response.data.payload.email})
          response.data.payload.birthDate && this.setState({email: response.data.payload.birthDate})
          response.data.payload.allergies && this.setState({selectAllergy: response.data.payload.allergies});
          response.data.payload.otherAllergies && this.setState({otherAllergies: response.data.payload.otherAllergies});
          response.data.payload.numberOfAccompanyChild && this.setState({noOfAccompanyGuestChild: response.data.payload.numberOfAccompanyChild });
          response.data.payload.numberOfAccompanyAdult && this.setState({noOfAccompanyGuestAdult: response.data.payload.numberOfAccompanyAdult });
          response.data.payload.extraData && this.setState({extraData: response.data.payload.extraData});
        
          response.data.payload.startDate && this.setState({arrivalDate: response.data.payload.startDate});
          response.data.payload.endDate && this.setState({departureDate: response.data.payload.endDate});

          (response.data.payload.isPreCheckInDone == false || response.data.payload.isPreCheckInDone == true) && this.setState({isPreCheckInDone: response.data.payload.isPreCheckInDone});

          if(response.data.payload.dynamicFormIndex){
            this.setState({dynamicFormIndex: response.data.payload.dynamicFormIndex});
          } else {
            if(this.props.preCheckInEnabled && response.data.payload.isPreCheckInDone == false && this.state.DynamicBookingFormRequestData[1]){
              this.setState({dynamicFormIndex: 1});
            } else {
              this.setState({dynamicFormIndex: 0});
            }
          }

          if(action == "bookingDataEnquiry" && localStorage.getItem("checkInGuestPreInfo")){
            const checkInGuestPreInfo = {
              lastName: this.state.lastName.trim() ,
              bookingNumber: response.data.payload.confirmationNumber && response.data.payload.confirmationNumber.trim(),
              checkinDate: this.state.selectedDate
            }

            localStorage.setItem("checkInGuestPreInfo", JSON.stringify(checkInGuestPreInfo));
          }

          if(this.props.currentWidgetObj.widgetType == "Pre Check-in" || toBool(this.props.preCheckInEnabled)){

            // checking preCheckIn state

            if(action == "bookingDataEnquiry"){
              if(toBool(response.data.payload.isPreCheckInDone)){
                if(!localStorage.getItem("X_CHECKIN_PQ_DATA")){
                    const preCheckInDataPayload = {
                      "confirmationNumber": response.data.payload.confirmationNumber,
                      "reservationNumber": response.data.payload.reservationNumber || "",
                      "idDetails": response.data.payload.idDetails || null,
                      "lastName": this.state.lastName,
                      "checkinDate": this.state.selectedDate,
                      "accompanyGuestData": response.data.payload.accompanyingGuestDetails,
                      "address": {...response.data.payload.address},
                      "allergies": response.data.payload.allergies || "",
                      "otherAllergies": response.data.payload.otherAllergies || "",
                      "email":response.data.payload.email || "",
                      "phone": response.data.payload.phoneNumber || "",
                      "birthDate": response.data.payload.birthDate || "",
                      "extraData":  response.data.payload.extraData || {},
                      "guestName": (this.state.firstName && this.state.firstName != "") ? this.state.firstName  + " " + this.state.lastName : this.state.lastName,
                      "tokenValueCard": ""
                    }

                    const CHECKIN_PQ_DATA = this.aesUtil.encrypt( globalSalt, globalIV, "1234567891234567", `${JSON.stringify(preCheckInDataPayload)}`);
                    sessionStorage.setItem("X_CHECKIN_PQ_DATA", CHECKIN_PQ_DATA);

                    fetchAdhoc(this.props);
                    this.props.getGuestItinerary();
                    this.props.setPreCheckInBookingState(true);

                    setTimeout(() => {
                      this.setState({preCheckInSuccess: true})
                    }, 100);
                    return;

                  } else {
                    // this handling is done from componentDidMount function
                  }
              }
            }
          }


          if(callingFunction == "clearIDVerification"){
            this.setState({showIdCardCapture: true})
            return;
          }


          if(this.props.cardChecksData.guestImagesCheckEnabled && response.data.payload.accompanyingGuestDetails.length > 0){
            if(callingFunction == "accGuest"){
              this.setNextScreen()
              return;
            }
          }

          // this will enable Accompany Guest flow (screen5)
          if( !this.props.cardChecksData.guestImagesCheckEnabled && (this.props.cardChecksData.accompanyGuestApproach == "freeformAdd" || (this.props.cardChecksData.accompanyGuestApproach && response.data.payload.accompanyingGuestDetails.length > 0))){
            if(action == "bookingEnquiry"){
              this.setState({showAccompanyGuestFlow: true});
            }
          }

          if(action == "bookingDataEnquiry")
            if(this.props.cardChecksData.idValidationInterface == "Clear"){
              this.setNextScreen("clearIDVerification")
            } else if(this.props.cardChecksData.idValidationInterface == "disabled"){
              this.setNextScreen("VerifyIdAndSelfie")
            } else {
              this.setState({showIdCardCapture: true})
            }
          else{
            console.log("setting next screen", action)
            this.setNextScreen()
          }
          
        }   
      })
      .catch((error) => {
        let errorMessage;
        console.log("error in booking api", error.message)
        this.setState({guest_book_loading:false});
        this.setState({showLoader: false})
        this.setState({CLEARLoader: false})
        if(callingFunction != "componentDidMount"){
          this.setState({guest_book_error:true});
          if (error.response && error.response.data && error.response.data.header){
            console.log('calling booking api', error.response)
            if(error.response.status == 400 || error.response.status == 409 || error.response.status == 412 || error.response.status == 503){
              this.setState({apiFailErrorMsg: error.response.data.header.status.msg})
              errorMessage = error.response.data.header.status.msg
            }else{
              this.setState({apiFailErrorMsg: null})
              errorMessage = "Something went wrong"
            }
          }else{
            errorMessage = "Something went wrong"
            this.setState({apiFailErrorMsg: null})
          }

          if(error.response.status == 400){
            if(error.response.data && error.response.data.header && error.response.data.header.status && error.response.data.header.status.guestCheckedIn && error.response.data.header.status.roomNumber){
              let loginGuestInfo = {
                lastName: this.state.lastName,
                roomNumber: error.response.data.header.status.roomNumber,
                confirmationNumber: this.state.bookingNumber.trim(),
                disableOtpFlow:this.props.externalSignIn.memberId  && error.response.data.header.status.loyaltyRewardIdFlag
              }
              this.props.setShowAutoLoginPopup(true, loginGuestInfo);
              return
            }
            
            if (error.response.data && error.response.data.payload && (
              error.response.data.payload.multipleAccompanyLastnameFound ||
              (this.props.allowUserLoginViaFindingReservation && (
                error.response.data.payload.inHouseAndDueInConflict ||
                error.response.data.payload.multipleInHouseConflict ||
                error.response.data.payload.multipleDueInConfict
              ))
            )) {
              const {
                inHouseAndDueInConflict,
                multipleInHouseConflict,
                multipleDueInConfict,
                multipleAccompanyLastnameFound,
                isConfirmationNumberRequired
              } = error.response.data.payload;

              handleGuestBookingConflict(
                {
                  inHouseAndDueInConflict,
                  multipleInHouseConflict,
                  multipleDueInConfict,
                  multipleAccompanyLastnameFound,
                  isConfirmationNumberRequired
                },
                this.props.setShowCustomPopup,  
                this.guestBookingHandler,
                this.guestBookFormData,
                this.props.t
              );
              return
            }

            if(this.state.preCheckInSuccess && error.response && error.response.data &&  error.response.data.payload && error.response.data.payload.errorCode == "noRecordFound" ){
              
              setTimeout(()=>{
                  wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                }, 2000);
            }

            this.clearGuestBookData();
            this.props.popupOpenClose(true, "We couldn't find your booking. Please check your details and try again, or contact the Front Desk for assistance.");
            return;
          }

          this.clearGuestBookData();
          if(error.response.data && error.response.data.header.status.isEarlyCheckInPossible){

            if(this.props.earlyCheckInPopUpDisabled){
              this.earlyCheckInConfirmFunc();
            } else {
              this.setState({askEarlyCheckIn: true});
            }
            
          } else {
            if(!error.response.data || !error.response.data.header.status.guestCheckedIn) this.setState({ showFailScreen: true});
          }

          this.props.sendAnalytics(
              null, // as no guesdetails in logout state 
              this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
              callingFunction == "accGuest" || callingFunction == "callBookingAPI" ? "COMPANION DETAILS - FAILED" : "BOOKING NUMBER - FAILED", 
              {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": callingFunction == "accGuest" ? "COMPANION DETAILS" : "BOOKING NUMBER", "errorMessage": errorMessage, "widgetSessionId": this.state.checkinSessionToken, checkinDate: this.state.selectedDate},
              0, 
              false // guest is not logged in
          );
        }
    });
  }


  sendDisclaimer = () => {

    this.setState({showLoader: true, loderMessage: "Please wait"});
    let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})

    this.props.sendAnalytics(
      null, // as no guesdetails in logout state 
      this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
      "DISCLAIMER ACCEPTED", 
      {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": this.state.showAccompanyGuestFlow ? "COMPANION DETAILS" : "BOOKING Details", "widgetSessionId": this.state.checkinSessionToken},
      0, 
      false, // guest is not logged in
      null
    );

    clientConfigApi.post("/mobileCheckIn/disclaimer",this.disclaimerFormData)
      .then((response) => {
        
        if(response.status != 200){
          this.setState({showLoader: false});
          this.setState({showFailScreen: true});

          this.props.sendAnalytics(
            null, // as no guesdetails in logout state 
            this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
            "DISCLAIMER SENT - FAILED", 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": this.state.showAccompanyGuestFlow ? "COMPANION DETAILS" : "BOOKING Details", "errorStatus": response.status, "widgetSessionId": this.state.checkinSessionToken},
            0, 
            false // guest is not logged in
        );

        } else {

          this.setState({ disclaimerAccepted: true }, () => {
            this.setState({showLoader: false});
            this.proceedToCheckIn();
          })

          this.props.sendAnalytics(
            null, // as no guesdetails in logout state 
            this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
            "DISCLAIMER SENT - SUCCESS", 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": this.state.showAccompanyGuestFlow ? "COMPANION DETAILS" : "BOOKING Details", "widgetSessionId": this.state.checkinSessionToken},
            0, 
            false, // guest is not logged in
            null
          );
        }
      })
      .catch((error) => {

        let errorMessage;
        console.log("error in discalimer api", error.message)


        this.setState({showLoader: false})


        if (error.response && error.response.data && error.response.data.header){
          console.log('calling booking api', error.response)
          if(error.response.status == 400 || error.response.status == 409 || error.response.status == 412 || error.response.status == 503){
            errorMessage = error.response.data.header.status.msg
          }else{
            errorMessage = "Something went wrong"
          }
        }else{
          errorMessage = "Something went wrong"
        }

        this.setState({apiFailErrorMsg: errorMessage})

        this.maxRetry = this.maxRetry-1;
        if(this.maxRetry <= 0){
          this.setState({exitCheckinFlow: true, apiFailErrorMsg: this.props.t('pre_checkIn.max_retry_error_message_disclaimer') });
        }

        
        if(!error.response.data || !error.response.data.header.status.guestCheckedIn) this.setState({showFailScreen: true});
        

        this.props.sendAnalytics(
            null, // as no guesdetails in logout state 
            this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
            "DISCLAIMER SENT - FAILED", 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": this.state.showAccompanyGuestFlow ? "COMPANION DETAILS" : "BOOKING Details", "errorMessage": errorMessage, "widgetSessionId": this.state.checkinSessionToken},
            0, 
            false // guest is not logged in
        );
      })
  }

  handleSkipUpsells = () => {
    this.setState({ showUpsells: false, continueUpsell: true }, () => {
      this.proceedToCheckIn();
    })
  }

  handleDisclaimer = (disclaimerSS) => {
    
    scrollToTop();
    this.disclaimerFormData.append("sessionToken",this.state.sessionToken);
    this.disclaimerFormData.append('confirmationNumber',this.state.bookingNumber.trim());
    this.disclaimerFormData.append('reservationNumber',this.state.reservationNumber.trim());
    
    let count = 0;

    console.log(disclaimerSS)
    disclaimerSS.map(disclaimer => {
      this.readFile(disclaimer,`image`,this.disclaimerFormData, () => {
        count = count + 1;
        console.log("read file count", count)
  
        if(count == disclaimerSS.length){
          setTimeout(() => {
            this.sendDisclaimer()
          }, 1500)
        }
      });
    })
  }

  handleCompanionGuestNext = () => {

    setTimeout(() => {
      console.log("adding up accompany guest in extraData" + this.props.accompanyGuests)
      this.setState({extraData: {...this.state.extraData, accompanyGuestData: this.props.accompanyGuests} })
    }, 2000);
    this.proceedToCheckIn();
  }

  handleBookingDetailsNext = () => {
    if(this.state.showAccompanyGuestFlow){
      this.setState({selectedComp: "screen5"});
    } else {
      this.proceedToCheckIn();
    }
  }

  proceedToCheckIn = () => {
    // show discalimer
    if (this.props.cardChecksData.showDisclaimer == true && this.state.disclaimerAccepted == false){
      this.setState({showDisclaimer: true});
      return;
    }


    if(this.state.isUpsellsAvailable && !this.state.continueUpsell){
      this.setState({showUpsells: true});
      return;
    }


    this.guestBookingHandler("", "beforePreCheckInCacheRenewel", "", "bookingEnquiry")
  }

  checkInInfoHandler(extraData){

    extraData.address && this.props.setCheckInAddress({...this.state.address, ...extraData.address});
    extraData.birthDate && extraData.birthDate != "" && this.setState({birthDate: extraData.birthDate});
    // extraData.lastName && extraData.lastName != "" && this.setState({lastName: extraData.lastName});
    extraData.firstName && extraData.firstName != "" && this.setState({firstName: extraData.firstName});
    this.setState({ userFinishedCheckInFlow: true, address: { ...this.state.address ,...extraData.address}, eta: extraData.eta, email: extraData.email, phone: extraData.phone, selectAllergy: extraData.allergies, otherAllergies: extraData.otherAllergies, extraData: {...extraData, accompanyGuestData: this.props.accompanyGuests, confirmationNumber: this.state.bookingNumber}},
      () => {
        this.handleBookingDetailsNext();
      }
    )
  }

  handleCheckinWorkflow(){
    if(this.props.currentWidgetObj.widgetType == "Pre Check-in") {
      this.preCheckInGuestHandler();
    } else {
      if(this.props.preCheckInEnabled){
        this.state.isPreCheckInDone ? this.checkInGuestHandler() : this.preCheckInGuestHandler();
      } else {
        this.checkInGuestHandler();
      }
    }
  }

  preCheckInGuestHandler(){

    this.setState({checkinGuest_loading:true, showLoader: true, loderMessage: "Please wait"});

    let idDetails = null
    
    if(!(this.props.cardChecksData.idValidationInterface == "Clear" || this.props.cardChecksData.idValidationInterface == "disabled")){
    idDetails = {
      "idType": this.props.selectedIdType.key,//this.getObject('idType'),
      "passportNumber": this.getObject("Id No."),
      "effectiveDate": this.dateFormatHandler(this.getObject("Date of Issue")),
      "expirationDate": this.dateFormatHandler(this.getObject("Date of Expiry")),
      "placeOfIssue": this.getObject("Place of Issue"),
      "countryOfIssue": this.getObject("Country Code"),
      "birthDate": this.dateFormatHandler(this.getObject("Date of Birth")),
      "nationality": this.getObject("Nationality")
    }}

    console.log("id details",idDetails);

    const preCheckInDataPayload = {
      "confirmationNumber": this.state.bookingNumber,
      "reservationNumber": this.state.reservationNumber,
      "idDetails": idDetails,
      "lastName": this.state.lastName,
      "checkinDate": this.state.selectedDate,
      "accompanyGuestData": this.props.accompanyGuests,
      "checkInTime": this.state.eta,
      "address": {
        addressLine1: this.state.address.addressLine1 || "",
        addressLine2: this.state.address.addressLine2 || "",
        city: this.state.address.city || "",
        state: this.state.address.state || "",
        postalCode: this.state.address.postalCode || "",
        country: this.state.address.country || ""
      },
      "allergies": this.state.selectAllergy,
      "otherAllergies": this.state.otherAllergies,
      "email": this.state.email,
      "phone": this.state.phone,
      "birthDate": this.state.birthDate,
      "extraData": this.state.extraData,
      "guestName": (this.state.firstName && this.state.firstName != "") ? this.state.firstName  + " " + this.state.lastName : this.state.lastName,
      "tokenValueCard": this.props.cardChecksData.cardTokenRequired ? this.state.cardToken : ""
    }
    
    clientConfigApi.post("/mobileCheckIn/preCheckInGuest", {
      "header": {
        "sessionToken": this.state.sessionToken,
        "actionKey": "doPreCheckIn"
      },
      "payload": preCheckInDataPayload
    })
    .then(response => {
      this.setState({checkinGuest_loading:false});
      if(response.status != 200){
        this.setState({showLoader:false});
        console.log("Checkin guest !ok",response);

        this.setState({checkinGuest_error:true, checkinGuest_error_msg: "Something went wrong."})

        this.maxRetry = this.maxRetry-1;
        if(this.maxRetry <= 0){
          this.setState({exitCheckinFlow: true, checkinGuest_error_msg: this.props.t('pre_checkIn.max_retry_error_message') });
        }

        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        this.props.sendAnalytics(
            null, // as no guesdetails in logout state 
            this.props.currentWidgetObj.widgetType || "Pre Check-in", 
            "PRE CHECK-IN - FAILED", 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING DETAILS", "widgetSessionId": this.state.checkinSessionToken, "checkinFailReason": "Something went wrong"},
            0, 
            false // guest is not logged in
        );
        
        if(window.FireBasePlugin){
          window.FirebasePlugin.logError("checkin Api failed with status: " + response.status)
        }
      }else{
        console.log("checkin guest response", response.data.payload);
        console.log("checkin guest room number", response.data.payload.roomNumber);
        this.setState({checkinGuest_error:false, checkinGuest_success:true});


        if(preCheckInDataPayload.idDetails && Object.keys(preCheckInDataPayload.idDetails).length > 0){
          let extra_guest_details = {
            birthDate: preCheckInDataPayload.birthDate != "" ? preCheckInDataPayload.birthDate : preCheckInDataPayload.idDetails.birthDate,
            nationality: preCheckInDataPayload.idDetails.nationality
          }

          localStorage.setItem("extra_guest_details", JSON.stringify(extra_guest_details));
        }

        const CHECKIN_PQ_DATA = this.aesUtil.encrypt(
          globalSalt,
          globalIV,
          "1234567891234567",
          `${JSON.stringify(preCheckInDataPayload)}`
        );

        if(WEB_VERSION_ENABLED){
          sessionStorage.setItem("X_CHECKIN_PQ_DATA", CHECKIN_PQ_DATA);
        } else {
          localStorage.setItem("X_CHECKIN_PQ_DATA", CHECKIN_PQ_DATA);

          handlePreCheckInStorage(CHECKIN_PQ_DATA)
        }

        fetchAdhoc(this.props);
        this.props.getGuestItinerary();
        this.props.setPreCheckInBookingState(true);

        this.props.selfieVideo && this.props.selfieVideo.videoUrl && localStorage.setItem("selfieVideoUrl", this.props.selfieVideo.videoUrl)

        if(this.props.currentWidgetObj.widgetType == "Pre Check-in" || this.props.mobileCheckInDisabled == true){
          this.setState({isPreCheckInDone: true}, () => {
            this.setState({showLoader:false});
            this.setState({preCheckInSuccess: true})
          })

        } else {
          setTimeout(() => {
            this.setState({isPreCheckInDone: true}, () => {
              this.preCheckInSuccessNext();
            })
          }, 100);
        }

        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})

        this.props.sendAnalytics(
            null, // as no guesdetails in logout state 
            this.props.currentWidgetObj.widgetType || "Pre Check-in", 
            "PRE CHECK-IN - SUCCESS", 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING DETAILS", "widgetSessionId": this.state.checkinSessionToken}, 
            0, 
            false // guest is not logged in
        );

      }
    })
    .catch(error => {
      this.setState({checkinGuest_success:true})
      this.setState({checkinGuest_error:true, checkinGuest_loading:false, showLoader:false , showFailScreen:true})
      if(window.FireBasePlugin){
        window.FirebasePlugin.logError("checkin Api failed :" + error)
      }
      let checkinFailReason
      if (error.response && error.response.data && error.response.data.header && error.response.status == 400){
        this.setState({apiFailErrorMsg:error.response.data.header.status.msg});
        checkinFailReason = error.response.data.header.status.msg
        // this.props.popupOpenClose(true, error.response.data.header.status.msg);
      } if (error.response && error.response.data && error.response.data.header && error.response.status == 408){
        this.setState({apiFailErrorMsg:error.response.data.header.status.msg});
        checkinFailReason = error.response.data.header.status.msg
        this.setState({goToFirstStep: true})
      } if (error.response && error.response.data && error.response.data.header){
        this.setState({apiFailErrorMsg:error.response.data.header.status.msg});
        checkinFailReason = error.response.data.header.status.msg
      } else{
        this.setState({apiFailErrorMsg: null})
        checkinFailReason = "Something went wrong, error message is not sent from CMS"
      }

      this.maxRetry = this.maxRetry-1;
        if(this.maxRetry <= 0){
          this.setState({exitCheckinFlow: true, apiFailErrorMsg: this.props.t('pre_checkIn.max_retry_error_message')});
        }

      let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        this.props.sendAnalytics(
            null, // as no guesdetails in logout state 
            this.props.currentWidgetObj.widgetType || "Pre Check-in", 
            "PRE CHECK-IN - FAILED", 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "errorMessage": checkinFailReason, "pageName": "BOOKING DETAILS", "widgetSessionId": this.state.checkinSessionToken},
            0, 
            false // guest is not logged in
        );

    })
  }

  checkInGuestHandler(props){

    this.setState({checkinGuest_loading:true, showLoader: true, loderMessage: "Please wait"});

    let idDetails = null
    
    if(!(this.props.cardChecksData.idValidationInterface == "Clear" || this.props.cardChecksData.idValidationInterface == "disabled") && !localStorage.getItem("X_CHECKIN_PQ_DATA") && !sessionStorage.getItem("X_CHECKIN_PQ_DATA")){
    idDetails = {
      "idType": this.props.selectedIdType.key,//this.getObject('idType'),
      "passportNumber": this.getObject("Id No."),
      "effectiveDate": this.dateFormatHandler(this.getObject("Date of Issue")),
      "expirationDate": this.dateFormatHandler(this.getObject("Date of Expiry")),
      "placeOfIssue": this.getObject("Place of Issue"),
      "countryOfIssue": this.getObject("Country Code"),
      "birthDate": this.dateFormatHandler(this.getObject("Date of Birth")),
      "nationality": this.getObject("Nationality")
    }}

    console.log("id details",idDetails);

    let checkInDataPayload = {};

    if(props && props.takeDataFromLocalStorage){
      checkInDataPayload = localStorage.getItem("X_CHECKIN_PQ_DATA") ? {...JSON.parse(this.aesUtil.decrypt(globalSalt, globalIV, "1234567891234567",localStorage.getItem("X_CHECKIN_PQ_DATA"))) , "isEarlyCheckIn": this.state.doEarlyCheckIn} : sessionStorage.getItem("X_CHECKIN_PQ_DATA") ? {...JSON.parse(this.aesUtil.decrypt(globalSalt, globalIV, "1234567891234567",sessionStorage.getItem("X_CHECKIN_PQ_DATA"))), "isEarlyCheckIn": this.state.doEarlyCheckIn} : null
    } else {
      checkInDataPayload = {
        "confirmationNumber": this.state.bookingNumber,
        "idDetails": idDetails,
        "accompanyGuestData": this.props.accompanyGuests,
        "address": {
          addressLine1: this.state.address.addressLine1 || "",
          addressLine2: this.state.address.addressLine2 || "",
          city: this.state.address.city || "",
          state: this.state.address.state || "",
          postalCode: this.state.address.postalCode || "",
          country: this.state.address.country || ""
        },
        "allergies": this.state.selectAllergy,
        "otherAllergies": this.state.otherAllergies,
        "email": this.state.email,
        "phone": this.state.phone,
        "birthDate": this.state.birthDate,
        "extraData": this.state.extraData,
        "tokenValueCard": this.props.cardChecksData.cardTokenRequired ? this.state.cardToken : "",
        "isEarlyCheckIn": this.state.doEarlyCheckIn,
      }
    }
    
    clientConfigApi.post("/mobileCheckIn/checkInGuest", {
      "header": {
        "sessionToken": this.state.sessionToken,
        "actionKey": "doCheckIn"
      },
      "payload": checkInDataPayload
    })
    .then(response => {
      if(response.status != 200){
        this.setState({doEarlyCheckIn: false});
        this.setState({checkinGuest_loading:false, showLoader:false});
        console.log("Checkin guest !ok",response);

        this.setState({checkinGuest_error:true, checkinGuest_error_msg: "Something went wrong."})

        this.maxRetry = this.maxRetry-1;
        if(this.maxRetry <= 0){
          this.setState({exitCheckinFlow: true, checkinGuest_error_msg: this.props.t('check_in.max_retry_error_message') });
        }

        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        this.props.sendAnalytics(
            null, // as no guesdetails in logout state 
            this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
            "CHECK-IN - FAILED", 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING DETAILS", "widgetSessionId": this.state.checkinSessionToken, "checkinFailReason": "Something went wrong"},
            0, 
            false // guest is not logged in
        );
        
        if(window.FireBasePlugin){
          window.FirebasePlugin.logError("checkin Api failed with status: " + response.status)
        }
      }else{
        console.log("checkin guest response", response.data.payload);
        console.log("checkin guest room number", response.data.payload.roomNumber);

        if(checkInDataPayload.idDetails && Object.keys(checkInDataPayload.idDetails).length > 0){
          let extra_guest_details = {
            birthDate: checkInDataPayload.birthDate != "" ? checkInDataPayload.birthDate : checkInDataPayload.idDetails.birthDate,
            nationality: checkInDataPayload.idDetails.nationality
          }

          localStorage.setItem("extra_guest_details", JSON.stringify(extra_guest_details));
        }

        this.checkinRoomNum = response.data.payload.roomNumber;
        this.props.setCheckinRoomNo(response.data.payload.roomNumber);
        this.setState({checkinGuest_error:false, checkinGuest_success:true});
        if(!this.props.cardChecksData.checkInNeedsFrontdeskValidation) localStorage.setItem('VerifiedUser', true)

        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        this.props.sendAnalytics(
            null, // as no guesdetails in logout state 
            this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
            "CHECK-IN - SUCCESS", 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING DETAILS", "widgetSessionId": this.state.checkinSessionToken}, 
            0, 
            false // guest is not logged in
        );

        setTimeout(() => {
          this.doCheckin();
        }, 100);
      }
    })
    .catch(error => {
      this.setState({checkinGuest_success:true})
      this.setState({checkinGuest_error:true, checkinGuest_loading:false, showLoader:false})
      this.setState({doEarlyCheckIn: false});
      if(window.FireBasePlugin){
        window.FirebasePlugin.logError("checkin Api failed :" + error)
      }
      let checkinFailReason
      if (error.response && error.response.data && error.response.data.header && error.response.status == 400){
        this.setState({apiFailErrorMsg:error.response.data.header.status.msg});
        checkinFailReason = error.response.data.header.status.msg
        // this.props.popupOpenClose(true, error.response.data.header.status.msg);
      } if (error.response && error.response.data && error.response.data.header && error.response.status == 408){
        this.setState({apiFailErrorMsg:error.response.data.header.status.msg});
        checkinFailReason = error.response.data.header.status.msg
        this.setState({goToFirstStep: true})
      } if (error.response && error.response.data && error.response.data.header){
        this.setState({apiFailErrorMsg:error.response.data.header.status.msg});
        checkinFailReason = error.response.data.header.status.msg
      } else{
        this.setState({apiFailErrorMsg: null})
        checkinFailReason = "Something went wrong, error message is not sent from CMS"
      }

      if(error.response && error.response.data && error.response.data.header && error.response.data.header.errorType == "RESV_IN_QUEUE"){

        this.setState({showReservationInQueuePopup: true})
        this.setState({exitCheckinFlow: true})

        const queueDataPayload = {
          "lastName": this.state.lastName,
          "checkinDate": this.state.selectedDate,
          "confirmationNumber": this.state.bookingNumber,
          "reservationNumber": this.state.reservationNumber,
          "guestName": (this.state.firstName && this.state.firstName != "") ? this.state.firstName  + " " + this.state.lastName : this.state.lastName
        }

        const CHECKIN_PQ_DATA = this.aesUtil.encrypt(globalSalt, globalIV, "1234567891234567", `${JSON.stringify(queueDataPayload)}`);
        if(WEB_VERSION_ENABLED){
          sessionStorage.setItem("X_CHECKIN_PQ_DATA", CHECKIN_PQ_DATA);
        } else {
          localStorage.setItem("X_CHECKIN_PQ_DATA", CHECKIN_PQ_DATA);

          handlePreCheckInStorage(CHECKIN_PQ_DATA)
        }

        fetchAdhoc(this.props);
        this.props.getGuestItinerary();
        this.props.setPreCheckInBookingState(true);

      } else {
        this.setState({showFailScreen:true})

        this.maxRetry = this.maxRetry-1;
        if(this.maxRetry <= 0){
          this.setState({exitCheckinFlow: true, apiFailErrorMsg: this.props.t('check_in.max_retry_error_message')});
        }
      }

      let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        this.props.sendAnalytics(
            null, // as no guesdetails in logout state 
            this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
            "CHECK-IN - FAILED", 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "errorMessage": checkinFailReason, "pageName": "BOOKING DETAILS", "widgetSessionId": this.state.checkinSessionToken},
            0, 
            false // guest is not logged in
        );

    })
  }

  dayFormatHandler(date){
    return date.date() < 10 ? `0${date.date()}` :  date.date()
  }


  monthFormatHandler = (month) => {
    return month < 10 ? `0${month}` : month;
  }

  getStateList = (id,arr) => {

    let stateList = [];

    for (let obj of arr){
      if(id == obj.countryId){
        stateList = obj.stateList
      }
    }

    return stateList;
  }

  handleCLEARData = (data) => {
    console.log("Clear Id verification data reponse" + JSON.stringify(data))
    this.setState({firstName: data.member_data.given_name})
    this.setState({phone: data.member_data.phone})
    this.setState({email: data.member_data.email})
    this.setState({birthDate: data.member_data.birthdate || ""})
  }

  componentDidUpdate(prevPro, prevState){
    
    mobileCheckinColorConfig(this.props.menuColor);


    if(prevState.reservationNumber != this.state.reservationNumber){
      this.checkUpsellsAvailable();
    }

    let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
    if(this.state.selectedComp == "screen4"){

      if(this.addressFlagCount < 1){
        this.setState({address: this.props.checkInAddress})
        this.addressFlagCount = this.addressFlagCount+1
      }
      if(prevState.selectedComp != this.state.selectedComp){
        this.props.setCheckinCurrentPageName("BOOKING DETAILS")
        const checkin_bdetails_event_sent = localStorage.getItem("checkin_bdetails_event_sent");
        if(!checkin_bdetails_event_sent){
          this.props.sendAnalytics(
              null, // as no guesdetails in logout state 
              this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
              "BOOKING DETAILS", 
              {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING DETAILS", "widgetSessionId": this.state.checkinSessionToken}, 
              0, 
              false, // guest is not logged in
              () => localStorage.setItem("checkin_bdetails_event_sent", true)
          );
        }
      }
    }

    if(this.state.selectedComp == "screen3"){
      if(prevState.selectedComp != this.state.selectedComp){
        const checkin_ccdetails_event_sent = localStorage.getItem("checkin_ccdetails_event_sent");
        this.props.setCheckinCurrentPageName("CREDIT CARD DETAILS")
        if(!checkin_ccdetails_event_sent){
          this.props.sendAnalytics(
              null, 
              this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
              "CREDIT CARD DETAILS", 
              {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "CREDIT CARD DETAILS", "widgetSessionId": this.state.checkinSessionToken}, 
              0, 
              false,
              () => localStorage.setItem("checkin_ccdetails_event_sent", true)
          );
        }
      }
    }

    if(this.props.abortCheckinProcess==true && !this.state.selectedComp &&  !this.state.showIdCardCapture && !this.state.showGDPR && !this.state.showSelfieCapture && !this.state.showVerifyConfidance ){
      this.props.setSelectedIdType(null);
      this.props.setIdCardImageBack(null)
      this.props.setIdCardImage(null)
      this.props.setSelfieVideo(null)
      this.props.setGoHome(true)
      localStorage.removeItem("GDPR-Response")

      
      this.props.setAbortCheckinProcess(false);
    }
  }

  cancelCheckinProcess=()=>{
        this.props.setShowCustomPopup(true,{
          htmlTagId:"cancel-checkin-process",
          title:(this.props.allowUserLoginViaFindingReservation && this.isBookingInformationPage()) ? this.props.t("check_in.cancel_checkin_process.findingReservation.title") : this.props.t("check_in.cancel_checkin_process.title"),
          subtitle:"",
          heading:(this.props.allowUserLoginViaFindingReservation && this.isBookingInformationPage()) ? this.props.t("check_in.cancel_checkin_process.findingReservation.heading"): this.props.t("check_in.cancel_checkin_process.heading"),
          subHeading:"",
          primaryButtonText:(this.props.allowUserLoginViaFindingReservation && this.isBookingInformationPage())? this.props.t("check_in.cancel_checkin_process.findingReservation.primaryButtonText"):  this.props.t("check_in.cancel_checkin_process.primaryButtonText"),
          secondaryButtonText:(this.props.allowUserLoginViaFindingReservation && this.isBookingInformationPage()) ? this.props.t("check_in.cancel_checkin_process.findingReservation.secondaryButtonText"): this.props.t("check_in.cancel_checkin_process.secondaryButtonText"),
          secondaryButtonStyleIsUnderline:true,
          primaryOnClick:()=>{this.props.setShowCustomPopup(false,{})},
          closeOnClick:()=>{this.props.setShowCustomPopup(false,{})},
          secondaryOnClick:()=>{this.props.setAbortCheckinProcess(true);this.props.setShowCustomPopup(false,{});}
      })   
  }

  isBookingInformationPage=()=>{
    if(!this.state.selectedComp &&  !this.state.showIdCardCapture && !this.state.showGDPR && !this.state.showSelfieCapture && !this.state.showVerifyConfidance ){
      return true;
    }
    return false;
  }

  componentDidMount(){

    setTimeout(()=>{
      scrollToTop();
    },100)
    
    const room = localStorage.getItem("room");

    if(room && room != "null"){
      this.setState({showErrorScreen:true, firstLaunch: false})
      return;
    }
    
    console.log("this.props.selectedIdType.key",this.props.selectedIdType && this.props.selectedIdType.key)
    const today = moment.utc(this.props.serverTimeDate);
    const date =  `${today.year()}-${this.monthFormatHandler(today.month() + 1)}-${this.dayFormatHandler(today)}`
    this.setState({todayDate: date});

    if(this.props.currentWidgetObj.widgetType != "Pre Check-in"){
      this.setState({inputDateFormat: dateFormatHandler(this.props.serverTimeDate, this.props.dateFormat)})
      this.setState({selectedDate: date});
    }

    window.scrollTo(0,0);

    if(this.props.currentWidgetObj.surveyId){
      this.setState({showGDPR: true})
    }
    // this.setState({lastName: this.getObject('Surname')});
    
    // if(this.props.selfieVideo){
    //   this.readFile(this.props.selfieVideo.videoUrl,"image",this.guestBookFormData);
    // }
    
    // if(this.props.idCardImage){
    //   this.readFile(this.props.idCardImage.imageUrl,"image",this.guestBookFormData);
    // }

    // this.setState({showLoader: true})
    // this.props.getCardChecksData(this.state.sessionToken, () => {
    //   this.guestBookingHandler(this.getObject('Surname'), "componentDidMount");
    // });

    GetDynamicBookingForm((data) => this.setState({DynamicBookingFormRequestData: data}))
    getAccompanyguestDynamicBookingForm((data) => this.setState({accompanyGuestDynamicFormRequestData: data}))
    
    mobileCheckinColorConfig(this.props.menuColor);
    this.props.getAllergyOptions(this.state.sessionToken);
    this.props.getCountryOptions(this.state.sessionToken);
    this.props.getGuestDocListData(this.state.sessionToken);
    this.setState({showLoader: true, loderMessage: "Loading..."})
    this.props.getCardChecksData(this.state.sessionToken, () => {this.setState({showLoader: false, loderMessage: ''});(this.maxRetry = (this.props.cardChecksData.guestValidationMaxRetry ? this.props.cardChecksData.guestValidationMaxRetry : 3))});

    const checkin_bnumber_event_sent = localStorage.getItem("checkin_bnumber_event_sent");
    const checkin_clicked_event_sent = localStorage.getItem("checkin_clicked_event_sent");
    let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})

    if(!checkin_clicked_event_sent){
      console.log("checkin_clicked_event_sent", !checkin_clicked_event_sent)
      this.props.setCheckinWidgetLaunchTime(new Date);
      this.props.sendAnalytics(
          null, // as no guesdetails in logout state 
          this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
          CLICKED, 
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING NUMBER", "widgetSessionId": this.state.checkinSessionToken, "widgetTypeName": this.props.currentWidgetObj.widgetTypeName }, 
          0, 
          false, // guest is not logged in,
          () => localStorage.setItem("checkin_clicked_event_sent", true)
      );
    }
    if(!checkin_bnumber_event_sent && !this.props.currentWidgetObj.surveyId){
      this.props.sendAnalytics(
          null, // as no guesdetails in logout state 
          this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
          "BOOKING NUMBER", 
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING NUMBER", "widgetSessionId": this.state.checkinSessionToken}, 
          0, 
          false, // guest is not logged in
          () => localStorage.setItem("checkin_bnumber_event_sent", true)
      );
    }
    this.props.setCheckinCurrentPageName("BOOKING NUMBER")

    if(this.props.disableCheckInWalkthrough){
      this.setState({firstLaunch: false});
    }


    if ( this.props.preCheckInEnabled && localStorage.getItem("X_CHECKIN_PQ_DATA")) {
      const preCheckInDoneInfo = JSON.parse(this.aesUtil.decrypt(globalSalt, globalIV, "1234567891234567",localStorage.getItem("X_CHECKIN_PQ_DATA")));

      if(preCheckInDoneInfo && preCheckInDoneInfo.checkinDate){
        this.setState({firstLaunch: false, showGDPR: false});
        this.setState({selectedDate: preCheckInDoneInfo.checkinDate, lastName: preCheckInDoneInfo.lastName, bookingNumber: preCheckInDoneInfo.confirmationNumber});
        this.setState({isPreCheckInDone: true, preCheckInSuccess: true});
      }

      return;
    }

    if(localStorage.getItem("checkInGuestPreInfo")){

      const checkInGuestPreInfo = JSON.parse(localStorage.getItem("checkInGuestPreInfo"));
      
      if(checkInGuestPreInfo){

        if(sessionStorage.getItem("clearWebVerification")) this.setState({firstLaunch: false, showGDPR: false});
        this.setState({ lastName:checkInGuestPreInfo.lastName, bookingNumber: checkInGuestPreInfo.bookingNumber || ""})
        if(checkInGuestPreInfo.bookingNumber && checkInGuestPreInfo.bookingNumber != "") {this.props.setBookingRef(checkInGuestPreInfo.bookingNumber); this.setState({errorScreenShown: true})};
        if(checkInGuestPreInfo.checkinDate) this.setState({selectedDate: checkInGuestPreInfo.checkinDate, inputDateFormat: dateFormatHandler(checkInGuestPreInfo.checkinDate, this.props.dateFormat)});

        setTimeout(() => {
          if( sessionStorage.getItem("clearWebVerification") && (checkInGuestPreInfo.lastName || checkInGuestPreInfo.bookingNumber))  {this.setState({CLEARLoader: true}); this.guestBookingHandler("", "clearIDVerification", "", "bookingEnquiry")}
          else if( sessionStorage.getItem("theKnowReservationRedirectForCheckIn") && checkInGuestPreInfo.lastName && checkInGuestPreInfo.bookingNumber && checkInGuestPreInfo.checkinDate )
            { this.guestBookingHandler("", "", "", "bookingDataEnquiry");
              sessionStorage.removeItem("theKnowReservationRedirectForCheckIn")
             }

        }, 200);

        // localStorage.removeItem("checkInGuestPreInfo")
      }
    }
    
  }

  checkUpsellsAvailable = () => {
    fetchUpsells({serverTimeDatePayload: this.props.serverTimeDatePayload, isPreCheckinProgress: true})
    .then((res) => {
        if (res.status == 200) {
          const updatedUpsellData = res.data
          .map(event => {
              if (event.type === "PRE_CHECK_IN" && event.qualityPlusRequestList && event.qualityPlusRequestList.length > 0) {
                
                // Return the updated event only if there are valid qualityPlusRequestList items
                const updatedQualityPlusRequestList = event.qualityPlusRequestList.filter(qps => !qps.isRequested);
                if (updatedQualityPlusRequestList.length > 0) {
                    return {
                        ...event,
                        qualityPlusRequestList: updatedQualityPlusRequestList
                    };
                }
              }
              return null; // Explicitly return null for non-matching events
          })
          .filter(event => event !== null); // Remove null values from the array

          if (updatedUpsellData.length > 0) {
              this.setState({ isUpsellsAvailable: true });
          } else {
            this.setState({ isUpsellsAvailable: false });
          }
        }
    })
    .catch((err) => {
      console.log("error fetching upsells")
    })
  }

  sendBookingNumberEvent = () => {

    let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})

    const checkin_bnumber_event_sent = localStorage.getItem("checkin_bnumber_event_sent");
    if(!checkin_bnumber_event_sent){
      this.props.sendAnalytics(
          null, // as no guesdetails in logout state 
          this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
          "BOOKING NUMBER", 
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING NUMBER", "widgetSessionId": this.state.checkinSessionToken}, 
          0, 
          false, // guest is not logged in
          () => localStorage.setItem("checkin_bnumber_event_sent", true)
      );
    }
  }

  abortCheckin =()=>{
    this.props.setAbortCheckinProcess(true) 
  }



  render() {
    const {t} = this.props
    return (
       <>
        {this.state.preCheckInSuccess ? <PreCheckInSuccess proceedToCheckIn={(this.state.selectedDate == this.state.todayDate)} userCompletedCheckInFlow={this.state.userFinishedCheckInFlow} bookingNumber={this.state.bookingNumber} proceed={() => this.preCheckInSuccessNext()} checkinGuestLoading={this.state.checkinGuest_loading} /> :
        !this.state.showIdCardCapture && !this.state.showGDPR && !this.state.showSelfieCapture && !this.state.showVerifyConfidance && <div className="main-container">
          {!this.state.selectedComp ? <Fragment>{console.log('this.guestBookFormData',this.guestBookFormData)}
            <header className="inner-pages w-footer subpages">
              <a onClick = {() => {
                this.props.setGoHome(true)
                localStorage.removeItem("GDPR-Response")
            }}  className="button-back"></a>
              <div className="heading align-center">
                  <div class="splash-brand">
                      <img src={`${CMSPath}${this.props.logo}`} />
                  </div>

                 
                {/* <p className="bold" style = {{color:"inherit"}}>{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
              </div>

              { process.env.REACT_APP_NEWER_DESIGN=="true" && <div class="cancel-check-in" onClick={this.cancelCheckinProcess}>
                      <div>Cancel </div>
                              <span style={{}}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                      <path d="M15 5L5 15M5 5L15 15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                              </span>
                        </div> }


            </header>
            <section className="widgets padding-0 margin-0 container-bg">

              <div class="widget-header widget-header-checkin booking-information">
                  { this.props.currentWidgetObj.widgetHeaderImageUrl && 
                      <div class="widget-header-img">
                          <img src={`${CMSPath}${this.props.currentWidgetObj.widgetHeaderImageUrl}`} alt={this.props.currentWidgetObj.displayName} />
                      </div>
                  }
                  <div class="widget-header-title">{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
              </div>


              <div className="widgets">
                <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                <h2 className = "all-caps" dangerouslySetInnerHTML={{__html:t('check_in.booking_details')}}></h2>
                </div>
                <div className="form-window">
                  <div className="form-window-heading">
                  {this.props.currentWidgetObj.widgetType == "Pre Check-in" ? 
                    t('pre_checkIn.enter_booking_information'):
                    t('check_in.enter_booking_information')}

                  </div>
                  <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                    <div className="form-row margin-bottom-1">
                      <label for="lastName">{t('check_in.last_name')} <span style = {{color:"red"}}>*</span></label>
                      <input name="lastName" autoComplete='family-name' id="guestlastName" type="text" value={this.state.lastName} onChange = {(e) => this.setState({lastName:e.target.value})}/>
                    </div>
  
                    { this.state.errorScreenShown && <div className="form-row margin-bottom-1">
                      <label for="bookingNum">{this.props.cardChecksData && this.props.cardChecksData.bookingNumberLabel ? this.props.cardChecksData.bookingNumberLabel : t('check_in.booking_no')} <span style = {{color:"red"}}>*</span></label>
                      <input name="bookingNum" id="bookingNum" type="text" value = {this.state.bookingNumber} onChange = {this.handleBookingRefNo}/>
                    </div>}

                    <div className="form-row margin-bottom-1">
                      <label>{t('check_in.checkin_date')} <span style = {{color: "red"}}>*</span></label>
                      { this.props.currentWidgetObj.widgetType == "Pre Check-in" ?
                      // <input name="scanId" onChange = {(e) => this.setState({selectedDate:e.target.value})} id="scanId" type="date" value = {this.state.selectedDate}/>
                      <input name="scanId" type="button" value={(this.props.dateFormat && this.props.dateFormat != null) ? this.state.inputDateFormat || t('check_in.checkin_date_placeholder') : this.state.selectedDate || t('check_in.checkin_date_placeholder')} onClick={() => this.setState({renderDateInput: !this.state.renderDateInput})} />
                      : <input name="scanId" id="scanId" disabled={true} type={(this.props.dateFormat && this.props.dateFormat != null) ? "text" : "Date"} value = {(this.props.dateFormat && this.props.dateFormat != null) ? this.state.inputDateFormat : this.state.todayDate}/>}
                    </div>
                    <p ><span style = {{color: "red"}}>*</span> {t('check_in.required')}</p>
                    <p className='checkin-required' style={{color: '#C60000', fontSize: '0.9rem', fontStyle:'italic'}}>{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.pre_checkIn_only_message') : t(`check_in.checkIn_only`)}</p>
                    
                    {this.props.cardChecksData.idValidationInterface == "Clear" && <p style={{color: '#C60000', fontSize: '0.9rem', fontStyle:'italic'}}>{t(`check_in.clear_notOpt_message`)}</p>}
                    {(this.state.guest_book_error && !this.state.guest_book_loading) && <p style = {{color:"red"}}>{this.state.guest_book_error_msg}</p>}
                    {this.state.guest_book_loading && <p>{t('check_in.please_wait')}</p>}
      
                    <div className="form-controls">
                      {this.props.cardChecksData.idValidationInterface == "Clear" ?
                          <button id='clear-next-button' class="primary w-100" onClick={() => { this.guestBookingHandler("", "", "", "bookingDataEnquiry"); }} disabled={this.state.guest_book_loading || (!this.state.lastName || !this.state.selectedDate)} > <span class="icon"> <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.05 48.26"><g id="Layer_1-2" data-name="Layer 1"><g><circle cx="24.47" cy="6.42" r="2.53" /><circle cx="24.47" cy="41.95" r="2.53" /><circle cx="20.47" cy="12.16" r="2.53" /><circle cx="14.84" cy="16.74" r="2.53" /><circle cx="7.58" cy="18.05" r="2.53" /><circle cx="6.47" cy="10.95" r="2.53" /><circle cx="14.26" cy="9.63" r="2.53" /><circle cx="14.26" cy="38.53" r="2.53" /><circle cx="17.37" cy="45.74" r="2.53" /><circle cx="17.37" cy="2.53" r="2.53" /><circle cx="6.47" cy="37.26" r="2.53" /><circle cx="7.58" cy="29.63" r="2.53" /><circle cx="12.32" cy="23.84" r="2.53" /><circle cx="2.53" cy="23.84" r="2.53" /><circle cx="14.84" cy="30.95" r="2.53" /><circle cx="20.47" cy="35.74" r="2.53" /><circle cx="28.58" cy="36.11" r="2.53" /><circle cx="34.21" cy="31.53" r="2.53" /><circle cx="41.47" cy="30.21" r="2.53" /><circle cx="42.58" cy="37.32" r="2.53" /><circle cx="34.79" cy="38.63" r="2.53" /><circle cx="34.79" cy="9.74" r="2.53" /><circle cx="31.68" cy="2.53" r="2.53" /><circle cx="31.68" cy="45.74" r="2.53" /><circle cx="42.58" cy="11" r="2.53" /><circle cx="41.47" cy="18.63" r="2.53" /><circle cx="36.74" cy="24.42" r="2.53" /><circle cx="46.53" cy="24.42" r="2.53" /><circle cx="34.21" cy="17.32" r="2.53" /><circle cx="28.58" cy="12.53" r="2.53" /></g></g></svg></span>
                            Verify with CLEAR
                          </button>
                      : <button className="primary w-100" onClick = {() => {this.guestBookingHandler("", "", "", "bookingDataEnquiry");}} disabled = {this.state.guest_book_loading || (!this.state.lastName || !this.state.selectedDate)}>{this.state.guest_book_error ? t('check_in.try_again') : t('check_in.continue')}</button>}
                    </div>
                  </div>
                </div> 
              </div>
            </section>

            {this.state.goBack ? <HashRouter>
              <Redirect exact to='/checkin/idCapture' /> 
            </HashRouter> : null}
          </Fragment>
          
              : this.state.selectedComp == "screen2" ?
                   
                (this.props.cardChecksData.guestImagesCheckEnabled && this.props.accompanyGuests.length > 0) ?
                  <AccompanyingGuestInput
                    idImageArray={this.state.idImageArray}
                    setError={(error) => this.setState({ apiFailErrorMsg: error, showFailScreen: true })}
                    showLoader={bool => this.setState({ showLoader: bool })}
                    back={() => {
                      this.setState({ selectedComp: null })
                      this.props.setAccompanyGuestData([])
                      this.props.setSelectedIdType(null);
                      this.props.setIdCardImageBack(null)
                      this.props.setIdCardImage(null)
                      this.props.setSelfieVideo(null)
                      let idArray = this.state.idImageArray
                      if (idArray.length > 0) {
                        idArray.map(guest => {
                          this.guestBookFormData.delete(`${guest.profileId}_docType`);
                          this.guestBookFormData.delete(`${guest.profileId}_image`);
                        })
                        this.setState({ idImageArray: [] })
                      }
                    }}
                    next={(idImageArray,updatedAccompanyGuests) => {
                      console.log(updatedAccompanyGuests,"updatedAccompanyGuests")
                      this.guestBookingHandler("", "accGuest", idImageArray)
                      this.setState({ idImageArray: idImageArray })
                      this.props.setAccompanyGuestData(updatedAccompanyGuests)
                    }}
                    guestList={this.props.accompanyGuests} />
                  : this.setState({ selectedComp: "screen3" })

                : this.state.selectedComp == "screen3" ?
                    this.props.cardChecksData.cardValidationEnabled ?
                    
                    this.props.cardChecksData.cardValidationInterface == "Stripe" ?
                      <StripeCardFlow
                        setupIntentClientSecret={this.state.setupIntentSecret}
                        publishableKey={this.props.cardChecksData.publishableKey}
                        showCardVerified={(userInfo) => { this.setState({ firstName: userInfo.firstName }); this.setState({ showCardVerified: true }) }}
                        backBtn={() => {
                          //  this.props.cardChecksData.guestImagesCheckEnabled ? this.setState({selectedComp : "screen2"}) : this.setState({selectedComp : null})}
                          // this.setState({goBack:true})
                          this.setState({ selectedComp: null })
                          this.props.setSelectedIdType(null);
                          this.props.setIdCardImageBack(null)
                          this.props.setIdCardImage(null)
                          this.props.setSelfieVideo(null)
                        }}
                        showLoader={bool => this.setState({ showLoader: bool })}
                        confirmationNumber={this.state.bookingNumber}
                        // firstName={this.getObject('Name')}
                        // lastName={this.getObject('Surname')}
                        firstName={this.state.firstName}
                        lastName={this.state.lastName}
                        showFailScreen={(status, message, exitCheckinFlow = false) => {
                          console.log("show Fail screen called")
                          this.setState({ showFailScreen: status, apiFailErrorMsg: message, exitCheckinFlow: exitCheckinFlow })
                        }}
                        setcardVerified={(status, token) => this.setState({ cardVerified: status, cardToken: token })}
                        iscardVerified={this.state.cardVerified}
                        next={(userInfo) => { this.setState({ firstName: userInfo.firstName }); this.setState({ selectedComp: "screen4" }); scrollToTop(); }}
                        goBack={() => this.setState({ goToFirstStep: true })}
                        countryOptions={this.props.countryOptions}
                        guestBookFormData={this.guestBookFormData}
                      />
                      : this.props.cardChecksData.cardValidationInterface == "Shift4_V1" ?
                        <Shift4
                          publicKey={this.props.cardChecksData.publishableKey}
                          secretKey={this.props.cardChecksData.apiSecretKey}
                          confirmationNumber={this.state.bookingNumber}
                          firstName={this.state.firstName}
                          lastName={this.state.lastName}
                          email={this.state.email}
                          iscardVerified={this.state.cardVerified}
                          showCardVerified={(userInfo) => { this.setState({ firstName: userInfo.firstName }); this.setState({ showCardVerified: true }) }}
                          showFailScreen={(status, message, callback) => {
                            if (callback) {
                              this.setState({ exitCheckinFlow: true })
                            }
                            this.setState({ showFailScreen: status, apiFailErrorMsg: message })
                          }}
                          backBtn={() => {
                            this.setState({ selectedComp: null })
                            this.props.setSelectedIdType(null);
                            this.props.setIdCardImageBack(null)
                            this.props.setIdCardImage(null)
                            this.props.setSelfieVideo(null)
                          }}
                          next={(userInfo) => { this.setState({ firstName: userInfo.firstName }); this.setState({ selectedComp: "screen4" }); scrollToTop() }} />
                        : this.props.cardChecksData.cardValidationInterface == "ElavonLB" ?
                            (
                              ELAVON_UPDATED_FLOW ?
                              <AddCard2
                              // firstName={this.getObject('Name')}
                              // lastName={this.getObject('Surname')}
                              firstName={this.state.firstName}
                              lastName={this.state.lastName}
                              confirmationNumber={this.state.bookingNumber}
                              address={this.state.address}
                              backBtn={() => {
                                //  this.props.cardChecksData.guestImagesCheckEnabled ? this.setState({selectedComp : "screen2"}) : this.setState({selectedComp : null})}
                                this.setState({ selectedComp: null })
                                this.props.setSelectedIdType(null);
                                this.props.setIdCardImageBack(null)
                                this.props.setIdCardImage(null)
                                this.props.setSelfieVideo(null)
                              }}
                              showCardVerified={(userInfo) => { this.setState({ firstName: userInfo.firstName }); this.setState({ showCardVerified: true }) }}
                              setcardVerified={(status, token) => this.setState({ cardVerified: status, cardToken: token })}
                              iscardVerified={this.state.cardVerified}
                              next={(userInfo) => { this.setState({ firstName: userInfo.firstName }); this.setState({ selectedComp: "screen4" }); scrollToTop() }}
                              showFailScreen={(status, message, callback) => {
                                if (callback) {
                                  this.setState({ exitCheckinFlow: true })
                                }
                                this.setState({ showFailScreen: status, apiFailErrorMsg: message })
                              }}
                              showLoader={bool => this.setState({ showLoader: bool })}
                              /> 
                              :
                              <AddCard
                                // firstName={this.getObject('Name')}
                                // lastName={this.getObject('Surname')}
                                firstName={this.state.firstName}
                                lastName={this.state.lastName}
                                confirmationNumber={this.state.bookingNumber}
                                address={this.state.address}
                                backBtn={() => {
                                  //  this.props.cardChecksData.guestImagesCheckEnabled ? this.setState({selectedComp : "screen2"}) : this.setState({selectedComp : null})}
                                  this.setState({ selectedComp: null })
                                  this.props.setSelectedIdType(null);
                                  this.props.setIdCardImageBack(null)
                                  this.props.setIdCardImage(null)
                                  this.props.setSelfieVideo(null)
                                }}
                                showCardVerified={(userInfo) => { this.setState({ firstName: userInfo.firstName }); this.setState({ showCardVerified: true }) }}
                                setcardVerified={(status, token) => this.setState({ cardVerified: status, cardToken: token })}
                                iscardVerified={this.state.cardVerified}
                                next={(userInfo) => { this.setState({ firstName: userInfo.firstName }); this.setState({ selectedComp: "screen4" }); scrollToTop() }}
                                showFailScreen={(status, message, callback) => {
                                  if (callback) {
                                    this.setState({ exitCheckinFlow: true })
                                  }
                                  this.setState({ showFailScreen: status, apiFailErrorMsg: message })
                                }}
                                showLoader={bool => this.setState({ showLoader: bool })}
                                /> 
                            )
                          : this.props.cardChecksData.cardValidationInterface == "Shift4"?
                            <Shift4_V2
                            lastName={this.state.lastName}
                            confirmationNumber={this.state.bookingNumber}
                            backBtn={() => {
                               this.setState({ selectedComp: null })
                              this.props.setSelectedIdType(null);
                              this.props.setIdCardImageBack(null)
                              this.props.setIdCardImage(null)
                              this.props.setSelfieVideo(null)
                            }}
                            showCardVerified={( userInfo) => { this.setState({ showCardVerified: true}) }}
                            setcardVerified={(status) => this.setState({ cardVerified: status })} // check for token
                            iscardVerified={this.state.cardVerified}
                            next={() => {this.setState({ selectedComp: "screen4" }); scrollToTop() }}
                            showFailScreen={(status, message, callback) => {
                              if(callback){
                                this.setState({selectedComp: null})
                                this.props.setSelectedIdType(null);
                                this.props.setIdCardImageBack(null)
                                this.props.setIdCardImage(null)
                                this.props.setSelfieVideo(null)
                              }                              
                              this.setState({ showFailScreen: status, apiFailErrorMsg: message })
                            }}
                            cancelCheckinProcess={this.cancelCheckinProcess}
                            showLoader={bool => this.setState({ showLoader: bool })}
                            /> : this.props.cardChecksData.cardValidationInterface == "FPay"?
                              <FreedomPay
                                firstName={this.state.firstName}
                                lastName={this.state.lastName}
                                phone={this.state.phone}
                                email={this.state.email}
                                confirmationNumber={this.state.bookingNumber}
                                countryOptions={this.props.countryOptions}
                                backBtn={() => {
                                  this.setState({ selectedComp: null })
                                  this.props.setSelectedIdType(null);
                                  this.props.setIdCardImageBack(null)
                                  this.props.setIdCardImage(null)
                                  this.props.setSelfieVideo(null)
                                }}
                                showCardVerified={(userInfo) => { this.setState({ firstName: userInfo.firstName, address: userInfo.address, phone: userInfo.phone, email: userInfo.email }); this.setState({ showCardVerified: true }) }}
                                setcardVerified={(status) => this.setState({ cardVerified: status })} // check for token
                                iscardVerified={this.state.cardVerified}
                                next={(userInfo) => { this.setState({ firstName: userInfo.firstName }); this.setState({ selectedComp: "screen4" }); scrollToTop() }}
                                showFailScreen={(status, message, callback) => {
                                  if(callback){
                                    this.setState({selectedComp: null})
                                    this.props.setSelectedIdType(null);
                                    this.props.setIdCardImageBack(null)
                                    this.props.setIdCardImage(null)
                                    this.props.setSelfieVideo(null)
                                  }
                                  this.setState({ showFailScreen: status, apiFailErrorMsg: message })
                                }}
                                showLoader={bool => this.setState({ showLoader: bool })}
                              /> : this.props.cardChecksData.cardValidationInterface == "Planet"?
                              <Planet
                                firstName={this.state.firstName}
                                lastName={this.state.lastName}
                                phone={this.state.phone}
                                email={this.state.email}
                                confirmationNumber={this.state.bookingNumber}
                                countryOptions={this.props.countryOptions}
                                backBtn={() => {
                                  this.setState({ selectedComp: null })
                                  this.props.setSelectedIdType(null);
                                  this.props.setIdCardImageBack(null)
                                  this.props.setIdCardImage(null)
                                  this.props.setSelfieVideo(null)
                                }}
                                showCardVerified={(userInfo) => { this.setState({ address: userInfo.address, email: userInfo.email }); this.setState({ showCardVerified: true }) }}
                                setcardVerified={(status) => this.setState({ cardVerified: status })} // check for token
                                iscardVerified={this.state.cardVerified}
                                next={(userInfo) => { this.setState({ selectedComp: "screen4" }); scrollToTop() }}
                                showFailScreen={(status, message, callback) => {
                                  if(callback){
                                    this.setState({selectedComp: null})
                                    this.props.setSelectedIdType(null);
                                    this.props.setIdCardImageBack(null)
                                    this.props.setIdCardImage(null)
                                    this.props.setSelfieVideo(null)
                                  }
                                  this.setState({ showFailScreen: status, apiFailErrorMsg: message })
                                }}
                                showLoader={bool => this.setState({ showLoader: bool })}
                              /> 
                            
                          : this.setState({ selectedComp: "screen4" })
                    : this.setState({ selectedComp: "screen4" })

                  : this.state.selectedComp == "screen4" ?
                    <BookingForm
                      checkinGuestLoading={this.state.checkinGuest_loading}
                      email={this.state.email}
                      phone={this.state.phone}
                      birthDate={this.state.birthDate}
                      eta={this.state.eta}
                      address={this.props.checkInAddress}
                      firstName={this.state.firstName}
                      lastName={this.state.lastName}
                      arrivalDate={this.state.arrivalDate}
                      departureDate={this.state.departureDate}
                      extraData={this.state.extraData}
                      isPreCheckInDone={this.state.isPreCheckInDone}
                      DynamicBookingFormRequestData={this.state.DynamicBookingFormRequestData}
                      dynamicFormIndex={this.state.dynamicFormIndex}
                      primaryButtonText={this.state.showAccompanyGuestFlow ? t('check_in.next') : this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.precheckin') : t('check_in.checkin')}
                      goBack={() => this.setState({ selectedComp: (this.props.cardChecksData.guestImagesCheckEnabled && this.props.accompanyGuests.length > 0) ? "screen2" : null })}
                      next={this.checkInInfoHandler}
                      cancelCheckinProcess={this.cancelCheckinProcess}
                    />

                    : this.state.selectedComp == "screen5" && (

                      this.props.cardChecksData.accompanyGuestApproach == "guestNames" ?
                        <AccompanyingGuestDetailsInput
                          setError={(error) => this.setState({ apiFailErrorMsg: error, showFailScreen: true })}
                          showLoader={bool => this.setState({ showLoader: bool })}
                          back={() => {this.setState({ selectedComp: "screen4" })}}
                          next={() => {this.handleCompanionGuestNext();}}
                          setAccompanyGuestData={(data) => this.props.setAccompanyGuestData(data)}
                          guestList={this.props.accompanyGuests}
                        />
                        : this.props.cardChecksData.accompanyGuestApproach == "dynamicGuestInfo" ?
                          <AccompanyingGuestDynamicForm
                            setError={(error) => this.setState({ apiFailErrorMsg: error, showFailScreen: true })}
                            showLoader={bool => this.setState({ showLoader: bool })}
                            accompanyGuestDynamicForm={this.state.accompanyGuestDynamicFormRequestData}
                            dynamicFormIndex={0}
                            back={() => {this.setState({ selectedComp: "screen4" })}}
                            next={() => {this.handleCompanionGuestNext();}}
                            setAccompanyGuestData={(data) => this.props.setAccompanyGuestData(data)}
                            guestList={this.props.accompanyGuests}
                          />

                          : this.props.cardChecksData.accompanyGuestApproach == "freeformAdd" ?
                            <AccompanyingGuestFreeForm
                              setError={(error) => this.setState({ apiFailErrorMsg: error, showFailScreen: true })}
                              showLoader={bool => this.setState({ showLoader: bool })}
                              back={() => {this.setState({ selectedComp: "screen4" })}}
                              next={() => {this.handleCompanionGuestNext();}}
                              setAccompanyGuestData={(data) => this.props.setAccompanyGuestData(data)}
                              guestList={this.props.accompanyGuests}
                            />
                            : null
                    )
            }

          { this.state.roomLinkSuccess == true &&
            <HashRouter>
              <section id="app-body" className="col">
              <Redirect exact to='/checkin/confidence/verified/booking/book_success/' />
              </section>
            </HashRouter>
          }

          { this.state.showCardVerified && 
            <SuccessFailScreen
              status={this.props.cardStatus} 
              statusTitle={this.props.statusTitle} 
              statusMessage1={this.props.statusMessage1} 
              statusMessage2={this.props.statusMessage2} 
              showClose={true}
              close={() => this.setState({showCardVerified: false})}
              continue={() => {
                console.log('next is getting called')
                  this.setState({selectedComp : "screen4"})
                  scrollToTop()
                  this.setState({showCardVerified: false})
                }}
            />}
        </div>}
        {this.state.showFailScreen && <APIFailScreen backBtn = {() => { this.state.exitCheckinFlow ? this.props.setGoHome(true) : this.state.goToFirstStep ? this.setState({selectedComp: null, showFailScreen:false, errorScreenShown: true }) : this.setState({showFailScreen:false, errorScreenShown: true})}} errorMsg = {this.state.apiFailErrorMsg}/>}
        {this.state.showReservationInQueuePopup && <ResvInQueuePopUP backBtn = {() => {this.props.setGoHome(true)}} errorMsg = {this.state.apiFailErrorMsg}/>}
        {this.state.askEarlyCheckIn && <EarlyCheckInPopUP backBtn = {() => { this.state.exitCheckinFlow ? this.props.setGoHome(true) : this.setState({askEarlyCheckIn: false}) }} errorMsg={this.state.apiFailErrorMsg} proceedWithEarlyCheckIn={() => this.earlyCheckInConfirmFunc()} />}
        {this.state.showErrorScreen && <LoggedInErrorScreen backBtn = {() => {this.props.setGoHome(true)}} errorMsg = {t('check_in.error_msg')} headerText = {t('check_in.error_header_text')}/>}
         {
          this.state.showIdCardCapture && ( SHOW_GDPR_BEFORE_ID_AND_SELFIE_SCAN ?  this.state.shownGdprBeforeIdAndSelfieScan : true ) ? 
          
            this.props.cardChecksData.idValidationInterface == "Clear" ?
              <ClearVerification 
                confirmationNumber={this.state.bookingNumber}
                checkinDate={this.state.selectedDate}
                lastName={this.state.lastName}
                skip={() => {this.setNextScreen("VerifyIdAndSelfie"); this.setState({showIdCardCapture: false})}} 
                goBack={() => this.setState({showIdCardCapture: false})} handleCLEARData={this.handleCLEARData} 
                setNextScreen={() => {this.setNextScreen("VerifyIdAndSelfie"); this.setState({showIdCardCapture: false})}} 
              />
            :
            process.env.REACT_APP_SHOW_SELFIE_AND_ID_SCAN_TOGETHER=="true" ?
              <ScanIdandSelfieTogether
                goBack={() => this.setState({showIdCardCapture: false})} 
                skip={() => {this.setNextScreen("VerifyIdAndSelfie"); this.setState({showIdCardCapture: false})}} 
                setConfidanceScreen={() => this.setState({showVerifyConfidance: true, showIdCardCapture: false})}
                cancelCheckinProcess={this.cancelCheckinProcess}
                /> 

              : <IdCardCapture 
                goBack={() => this.setState({showIdCardCapture: false})} 
                skip={() => {this.setNextScreen("VerifyIdAndSelfie"); this.setState({showIdCardCapture: false})}} 
                setSelfieScreen={() => this.setState({showIdCardCapture: false, showSelfieCapture: this.props.cardChecksData.disableLivelinessCheck ? false : true,  showVerifyConfidance: this.props.cardChecksData.disableLivelinessCheck ? true : false})} 
              />
          : null
        }

        {
           SHOW_GDPR_BEFORE_ID_AND_SELFIE_SCAN && this.state.showIdCardCapture && !this.state.shownGdprBeforeIdAndSelfieScan && < GdprBeforeIdAndSelfieScan proceed={()=>{this.setState({shownGdprBeforeIdAndSelfieScan: true}); }}   goBack={() => {this.setState({showIdCardCapture: false}); }} />
        }

        {
          this.state.showSelfieCapture && <SelfieCapture goBack={() => this.setState({showIdCardCapture: true, showSelfieCapture: false})} setConfidanceScreen={() => this.setState({showVerifyConfidance: true, showSelfieCapture: false})} />
        }
        {
          this.state.showVerifyConfidance && <VerifyConfidance goBack={() => this.setState({showVerifyConfidance: false, showIdCardCapture: true})} goBacktoSelfie={() => this.setState({showVerifyConfidance: false, showSelfieCapture: true})} setNextScreen={() => 
            {
              let alreadyCalled=false;
              return ()=>{
                if(!alreadyCalled){
                  alreadyCalled=true;
                  this.checkIDLastName();
                } 
              }
            }
          }
             />
        }
        {
          this.state.firstLaunch && (this.props.allowUserLoginViaFindingReservation ? (Boolean(this.state.showIdCardCapture)) : true) && <CheckinStepsGuide guestImagesCheckEnabled={this.props.cardChecksData.guestImagesCheckEnabled} accompanyGuestEnabled={this.props.cardChecksData.accompanyGuestApproach} cardCheckEnabled={this.props.cardChecksData.cardValidationEnabled} idVerificationDisabled={this.props.cardChecksData.idValidationInterface == "disabled" ? true : false} clearFlowEnabled={this.props.cardChecksData.idValidationInterface == "Clear" ? true : false} setStepsGuide={() => this.setState({firstLaunch: false})}  backActionIfAllowUserLoginViaFindingReservationEnabled={()=>{this.setState({showIdCardCapture: false})}} />
        }
        {
          this.state.showDisclaimer && 
          <Disclaimer 
              userDetails={{ 
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                guestName: this.state.firstName ? this.state.firstName + " " + this.state.lastName : this.state.lastName,
                email: this.state.email, phone: this.state.phone, 
                passportNumber: this.props.selectedIdType && this.props.selectedIdType.key.toLowerCase() == "passport" ? this.getObject("Id No.") : "", 
                nationality: this.getObject("Nationality")
              }} 
              isChildAsAccompanyGuest={this.state.noOfAccompanyGuestChild > 0 ? true : false} 
              reservationNumber={this.state.reservationNumber} 
              setAPIFailScreen={(status) => this.setState({showFailScreen: status, showDisclaimer: false, apiFailErrorMsg: "Failed to fetch disclaimer"})} 
              setLoader={(status, msg) => this.setState({showLoader: status, loderMessage: msg})} 
              goNext={(disclaimerSS) => { this.setState({showLoader: true, loderMessage: "Please wait", showDisclaimer: false}); this.handleDisclaimer(disclaimerSS);}} 
              goBack={() => {this.setState({showDisclaimer: false});}} 
            />
        }
        {
          this.state.showUpsells && 
          <Upsells
            isPreCheckinProgress={true}
            disableBackButton={true}
            title={t('check_in.special_offers')}
            guestDetails={{
              reservationNumber: this.state.reservationNumber
            }}
            next={this.handleSkipUpsells}
          />
        }

        {
          this.state.showGDPR && <GdprPolicy setAPIFailScreen={(status) => this.setState({showFailScreen: status, exitCheckinFlow: true, apiFailErrorMsg: "Failed to get GDPR policy"})} setLoader={(status, msg) => this.setState({showLoader: status, displayMsg: msg})} currentWidget={this.props.currentWidgetObj} goNext={() => {this.setState({showGDPR: false});this.sendBookingNumberEvent();}} goBack={() => {this.props.setGoHome(true);localStorage.removeItem("GDPR-Response")}}  />
        }
        { (this.state.showLoader || this.state.CLEARLoader) &&  <Loader displayMsg={this.state.loderMessage || "Verifying data..."} showClose={true}
                                                            close={() => {this.props.setGoHome(true);}}  />}

        { this.state.renderDateInput &&
          <div className="overlay" onClick={() => this.setState({renderDateInput: false})}>
          <div onClick={(event) => {event.stopPropagation()}} class="overlay-date">
              <style>{this.dateInputCss}</style>
              <DayPicker
                  mode="single"
                  selected={new Date(this.state.selectedDate)}
                  onSelect={(selectedDate) => this.handlePreCheckInSelectedDate(selectedDate)}
                  disabled={{
                      // before: new Date(this.props.serverTimeDate.split("T")[0] + "T00:00:00"),
                      after: this.props.preCheckInTimeLimit && this.props.preCheckInTimeLimit >= 0 ? new Date(new Date(this.props.serverTimeDate.split("T")[0] + "T00:00:00").getTime() + (Math.floor(this.props.preCheckInTimeLimit / 24)) * 24 * 60 * 60 * 1000) : undefined
                  }}
              />
          </div>
        </div>
        }
        </>
    )
  }
}


const mapStateToProps = state => {
  return{
    idCardResponse: state.store2.idCardResponse,
    idCardBackResponse: state.store2.idCardBackResponse,
    selfieResponse: state.store2.selfieResponse,
    bookingRef: state.store2.booking_ref,
    idCardImage: state.store2.idCardImage,
    idCardImageBack: state.store2.idCardImageBack,
    selfieVideo: state.store2.selfieVideo,
    cardChecksData: state.store2.cardChecksData,
    cardStatus: state.store2.checkinCard.cardStatus,
    statusTitle: state.store2.checkinCard.statusTitle,
    statusMessage1: state.store2.checkinCard.statusMessage1,
    statusMessage2: state.store2.checkinCard.statusMessage2,
    menuColor: state.store.home.MenuColor,
    allergyOptions: state.store2.guestBooking.allergyOptions,
    countryOptions: state.store2.guestBooking.countryOptions,
    selectedIdType: state.store2.selectedIdType,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    accompanyGuests: state.store2.accompanyGuests,
    abortCheckinProcess: state.store2.abortCheckinProcess,
    serverTimeDatePayload: state.store.home.serverTimeDate || {},
    disableCheckInWalkthrough: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.disableCheckInWalkthrough ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.disableCheckInWalkthrough) : false,
    checkInStartTime: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.checkInStartTime,
    preCheckInTimeLimit: state.store.home.clientConfig.webAppWidgetsInfo ? state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInTimeLimit : undefined,
    preCheckInEnabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled) : false,
    mobileCheckInDisabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.mobileCheckInDisabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.mobileCheckInDisabled) : false,
    earlyCheckInPopUpDisabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.earlyCheckInPopUpDisabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.earlyCheckInPopUpDisabled) : false,
    serverTimeDate: state.store.home.serverTimeDate.date,
    dateFormat: state.store.home.clientConfig.extraConfigParam 
        ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
    checkInAddress : state.store2.checkInAddress,
    externalSignIn: state.store2.externalSignIn,
    allowUserLoginViaFindingReservation: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.allowUserLoginViaFindingReservation,
    bgImage: state.store.home.currentDuration.launcherBgImageUrl,
    location_data: state.store2.location_data,
    tncUrl: state.store.home.tncUrl,
    privacyPolicyUrl: state.store.home.privacyPolicyUrl,


  }
}

export default connect(mapStateToProps,{ 
  setBookingRef, 
  setCheckinRoomNo, 
  validateGuestdetail,
  popupOpenClose,
  getAllergyOptions,
  getCountryOptions,
  setPreCheckInBookingState,
  getCardChecksData,
  getGuestDocListData,
  setGoHome,
  updateAdhocData,
  showAdhocAction,
  getGuestItinerary,
  setShowAutoLoginPopup,
  currentWidget,
  setShowCustomPopup,
  setAbortCheckinProcess,
  cardValidation, setAccompanyGuestData, setCheckinWidgetLaunchTime,
  setSelfieVideo, setIdCardImage, setIdCardImageBack, setCheckInAddress, sendAnalytics, setCheckinCurrentPageName, setSelectedIdType
 })(withTranslation('translations')(Booking));
